import { Button, Divider } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link as RouterLink } from 'react-router-dom';

import CarImg from '../images/hero/HeroRightImages/carImg.png';
import EngineIcon from '../images/hero/HeroRightImages/engineIcon.png';
import CarLoanIcon from '../images/hero/HeroRightImages/carLoanIcon.png';
import CarPaintIcon from '../images/hero/HeroRightImages/carPaintIcon.png';
import FairPriceIcon from '../images/hero/HeroRightImages/fairPriceIcon.png';
import ScannerIcon from '../images/hero/HeroRightImages/scannerIcon.png';
import WatchImg from '../images/hero/HeroRightImages/watchImg.png';

import AiDrivenLogo from '../../assets/gradeIcons/aiDrivenEngine.png';
import OBDScanner from '../../assets/gradeIcons/OBDScanner.png';
import UnbiasedCustomer from '../../assets/gradeIcons/unbiasedCustomer.png';

import one from '../images/queryComponent/oneICon.png';
import two from '../images/queryComponent/twoIcon.png';
import three from '../images/queryComponent/threeIcon.png';

import roadsideAssist from '../numberIcons/roadsideAssist.png';
import cities from '../numberIcons/cities.png';
import customerSupport from '../numberIcons/customerSupport.png';
import kilometer from '../numberIcons/kmDriven.png';
import warranty from '../numberIcons/warranty.png';
import inspected from '../numberIcons/inspected.png';
import { Link } from 'react-router-dom';
import recomended from '../../assets/images/recommended.png';

import Malaysia from '../../assets/icons/cityIcons/malaysia.png';

export const MalaysiaContent = {
  headerPage: {
    menuItems: (
      <>
        <li>
          <a aria-label="" href="#inspection-plans">
            Pelan Pemeriksaan
          </a>
        </li>
        <li>
          <a aria-label="" href="#how-it-works">
            Cara Ia Berfungsi
          </a>
        </li>
        <li>
          <a aria-label="" href="#why-wisedrive">
            Kenapa Wisedrive
          </a>
        </li>
        <li>
          <a aria-label="" href="#contact-us">
            Hubungi Kami
          </a>
        </li>
      </>
    ),
    languages: [
      {
        id: 'en',
        label: 'EN',
      },
      {
        id: 'my',
        label: 'MY',
      },
    ],
  },
  heroPage: {
    headLine: (
      <div className="hero-headline">
        <img loading="lazy" src={CarImg} width="30px" alt="Imej Kereta" />
        <p>Beli Kereta Terpakai?</p>
      </div>
    ),
    header: (
      <h2>
        Lakukan Pemeriksaan Kereta Dahulu,
        <span style={{ color: 'red' }}>
          <br /> Jangan Menyesal Kemudian!
        </span>
      </h2>
    ),
    subPoints: [
      'Elakkan Kos Baik Pulih yang Mahal',
      'Dapatkan Keadaan Kereta Sebenar',
      'Pembelian Tanpa Risiko',
      'Pemeriksaan Pakar Dipercayai',
    ],
    btnText: 'Tempah Pemeriksaan',
    cardTitles: [
      {
        color: '#003cc5',
        content: (
          <>
            <h4>200+</h4>
            <p style={{ color: 'white' }}>Titik pemeriksaan dilindungi</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={EngineIcon} alt="" />
            <p>Enjin & Transmisi</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarPaintIcon} alt="" />
            <p>Pemeriksaan Kemek & Cat</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={ScannerIcon} alt="" />
            <p>Imbasan OBD2 Lanjutan</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={CarLoanIcon} alt="" />
            <p>Semakan Kewangan & RTO</p>
          </>
        ),
      },
      {
        content: (
          <>
            <img loading="lazy" src={FairPriceIcon} alt="" />
            <p>Cadangan Harga Berpatutan</p>
          </>
        ),
      },
    ],
    leadForm: (
      <h6 style={{ color: '#e64a19', fontFamily: 'matterSemiBold' }}>
        Jangan Ambil Risiko dengan Wang Titik Peluh Anda -{' '}
        <span style={{ color: '#003cc5' }}>Bercakap dengan Kami</span>
      </h6>
    ),
    leadFormBtntxt: 'Mohon Panggilan Balik',
    leadFormDisclaimer:
      'Dengan menghubungi kami, anda bersetuju dengan terma perkhidmatan dan dasar privasi kami',
    rightFooter: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          style={{
            background: '#ffea5b',
            display: 'flex',
            gap: '10px',
            padding: '2px 11px',
            textAlign: 'center',
            marginBottom: '10px',
          }}
        >
          <img loading="lazy" src={WatchImg} width="30px" alt="Jam" />
          Dapatkan Laporan Pemeriksaan dalam 2 Jam*
        </p>
        <p className="hero-right-footer-p">
          150,000 pelanggan telah memeriksa kereta mereka dengan kami dan
          terselamat daripada membeli kereta yang terlibat kemalangan, banjir,
          atau kerosakan enjin.
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            Pemeriksaan pihak ke-3 yang tidak berat sebelah menjamin ketenangan
            fikiran semasa membeli kereta terpakai!!
          </strong>
        </p>
      </div>
    ),
    rightFooterHero: (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <p className="hero-right-footer-p">
          Pemeriksaan pakar kami telah menjimatkan pelanggan{' '}
          <strong>RM 130 Juta </strong>
          dengan mengelakkan kesilapan mahal pada kereta yang mempunyai
          kerosakan enjin tersembunyi dan pembaikan selepas pembelian.
        </p>
        <p className="hero-right-footer-p">
          <strong style={{ color: 'red' }}>
            Jangan pertaruhkan wang hasil titik peluh anda - periksa kereta
            terpakai anda hari ini!
          </strong>
        </p>
      </div>
    ),
  },
  planDetails: {
    header: (
      <div className="inspection-header-container">
        <div>
          <h2 className="inspection-header">
            Kami lakukan segala-galanya untuk melindungi kereta anda
          </h2>
          <h2 className="inspection-header-red">200+ Titik Pemeriksaan.</h2>
        </div>
        <div>
          <img
            loading="lazy"
            src={recomended}
            alt=""
            className="logo-web"
          ></img>
          <div className="mbl-View-only">
            <img
              loading="lazy"
              src={recomended}
              alt=""
              className="recomended-img"
            ></img>
            <RouterLink
              style={{
                color: '#003cc5',
                fontSize: '18px',
                border: '1px solid',
                borderColor: '#003cc5',
                padding: '5px',
                borderRadius: '6px',
              }}
              target="_blank"
              to={'/sample-report'}
            >
              <p
                style={{
                  color: 'rgb(0, 60, 197)',
                  fontFamily: 'matterThin',
                  fontSize: '12px',
                  paddingLeft: '0px !important',
                  paddingTop: '0px !important',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                Laporan Contoh
                <OpenInNewIcon fontSize="small" />
              </p>
            </RouterLink>
          </div>
        </div>
      </div>
    ),
    currency: 'RM',
    noteTaxes: 'Termasuk semua cukai',
    infoNote:
      'Laporan pemeriksaan akan dihantar melalui WhatsApp ke nombor telefon bimbit yang didaftarkan semasa tempahan.',
    inspectionCardsArray: [
      {
        header: 'Pemeriksaan Fizikal / Manual',
        checkPoints: '135',
        inspectionItems: [
          'Pemeriksaan Enjin & Transmisi',
          'Pemeriksaan Komponen Elektrik',
          'Pemeriksaan Komponen Mekanikal',
          'Pemeriksaan Dalaman & Luaran',
        ],
        additionalBenifits: {
          header: 'Manfaat Tambahan',
          data: [
            'Pemeriksaan kenderaan banjir, Pemeriksaan pembaikan enjin utama',
            'Pemeriksaan fungsi bateri, Pemeriksaan penipuan odometer',
            'Pemeriksaan sistem brek, Pemeriksaan sistem bahan api',
          ],
        },
      },
      {
        header: 'Ujian Pengimbas OBD2 Lanjutan',
        checkPoints: '76',
        inspectionItems: [
          'Modul Kawalan Enjin (ECM)',
          'Modul Kawalan Transmisi',
          'Modul Kawalan Badan (BCM)',
          'Pemeriksaan dan Analisis Kod Ralat',
        ],
        additionalBenifits: {
          header: 'Manfaat Tambahan',
          data: [
            'Analisis kemungkinan kegagalan enjin, Analisis kemungkinan kegagalan transmisi',
            'Pemeriksaan kestabilan pemanduan pada kelajuan tinggi menggunakan pengimbas OBD-2 canggih',
            'Pemeriksaan pencegahan pembaikan mahal',
          ],
        },
      },
      {
        header: 'Pengesahan JPJ & Polis',
        checkPoints: '29',
        inspectionItems: [
          'Semakan Butiran Pendaftaran Kenderaan',
          'Semakan Nombor Enjin dan VIN',
          'Semakan Status Insurans',
          'Semakan Tempoh Sah Insurans',
        ],
        additionalBenifits: {
          header: 'Manfaat Tambahan',
          data: [
            'Butiran RTO menyemak ketulenan kenderaan',
            'Pengesanan penipuan melalui semakan nombor Enjin dan VIN',
            'Semakan butiran insurans membantu anda berunding dengan lebih baik',
          ],
        },
      },
      {
        header: 'Sokongan Teknikal Tambahan',
        checkPoints: '76',
        inspectionItems: [
          'Anggaran Harga Berpatutan',
          'Anggaran Kos Pembaikan',
          'Nasihat Pakar Mekanik',
          'Jaminan Lanjutan sehingga 2 tahun',
        ],
      },
    ],
    partPaymentAmount: 100,
    partialBtnText: 'Bayar RM 100 Pendahuluan',
    btnBookInspection: 'Tempah Pemeriksaan',
    sampleBtnText: 'Laporan Contoh',
    steps: [
      'Daftar Dengan No. Telefon Bimbit',
      'Masukkan Butiran Kereta',
      'Pilih Bandar Untuk Pemeriksaan',
      'Sahkan Butiran Pembayaran',
    ],

    formHeader: (
      <>
        Membuka Piawaian
        <br /> Pemeriksaan Kereta
      </>
    ),
    errorName: 'Sila masukkan nama',
    labelName: 'Nama',
    errorMobile: 'Sila masukkan nombor',
    labelMobile: 'No. Telefon',
    otpSuccessMsg: 'OTP dihantar melalui SMS ke nombor telefon bimbit anda',
    resendOtpLbl: 'Hantar Semula OTP',
    sendOtpLbl: 'Hantar OTP',
    entrrOtpLbl: 'Masukkan OTP',
    entrrOtpErrorLbl: 'Sila Masukkan OTP yang Sah',
    verifyOtpBth: 'Sahkan OTP',
    otpNote: (
      <>
        Dengan menghubungi kami, anda bersetuju dengan{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/my/inspection-terms-and-conditions'}
        >
          <strong>Terma Perkhidmatan</strong> dan <strong>Dasar Privasi</strong>
        </RouterLink>
      </>
    ),
    registerHeader: 'Masukkan Nombor Pendaftaran Kereta',
    searchBtn: 'CARI',
    carMakeLbl: 'Jenama',
    carModelLbl: 'Model',
    carMfYearLbl: 'Tahun Pembuatan',
    carTypeLbl: 'Jenis',
    carColorLbl: 'Warna',
    confirmBtn: 'Ya, Sahkan Kereta',
    skipBtn: 'Langkau ke Pembayaran',
    cityIconArray: [
      {
        name: 'Kaula Lumpur',
        icon: Malaysia,
      },
      {
        name: 'Shah Alam',
        icon: Malaysia,
      },
      {
        name: 'Pulau Penang',
        icon: Malaysia,
      },
      {
        name: 'Johor Bharu',
        icon: Malaysia,
      },
      {
        name: 'Kota Bharu',
        icon: Malaysia,
      },
    ],
    selectTimeLbl: 'Pilih Masa',
    selectDateLbl: 'Pilih Tarikh',
    cityLbl: 'Bandar',
    addressLbl: 'Masukkan Alamat Pemeriksaan',
    confirmInspectionBtn: 'Sahkan Pemeriksaan',
    payHeadr: 'Ringkasan',
    pkgAmtLbl: 'Jumlah Pakej',
    inspCurrencyLbl: ' Pemeriksaan x RM',
    totalAmtLbl: 'Jumlah Keseluruhan',
    partialBtnNote:
      'Baki jumlah perlu dibayar selepas pemeriksaan kereta selesai',
    fullBtnText: 'Bayar Jumlah Penuh',
    fullBtnNote: (
      <>
        Dengan memilih pembayaran penuh, anda bersetuju dengan{' '}
        <strong>Terma Perkhidmatan</strong> dan <strong>Dasar Privasi</strong>
      </>
    ),
    termsTxt: (
      <>
        Dengan meneruskan, saya memahami dan bersetuju dengan{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/my/inspection-terms-and-conditions'}
        >
          <strong>Terma Perkhidmatan</strong> dan <strong>Dasar Privasi</strong>
        </RouterLink>
        dari Wisedrive Technologies (M) Sdn. Bhd.
      </>
    ),
    secureLbl: 'Pembayaran dijamin oleh',
    whatsappFooterTxt: (
      <>
        Sapa kami di{' '}
        <span
          style={{
            fontSize: '16px',
            fontFamily: 'matterBold',
          }}
        >
          WhatsApp di +60 122559610{' '}
        </span>{' '}
        untuk sebarang pertanyaan dari 9 pagi - 7 malam Isnin - Sabtu.
      </>
    ),
    brandsCovered: 'Jenama yang Diliputi',
    brandCoveredHeader: 'Jenama yang Diliputi dalam setiap pakej pemeriksaan',
    brandsCoveredNote:
      'Semua jenis kereta seperti hatchback, sedan, MUV, MPV, SUV diliputi dalam setiap jenama',
    standardLbl: 'Standard',
    luxaryLbl: 'Mewah',
    brandsStandardArray: [
      'MARUTHI SUZUKI',
      'HYUNDAI',
      'HONDA',
      'KIA',
      'TOYOTA',
      'VOLKSWAGEN',
      'SKODA',
      'RENAULT',
      'NISSAN',
      'MAHINDRA',
      'TATA MOTORS',
      'FORD',
      'FIAT',
      'DATSUN',
      'MISTUBISHI',
      'Chery',
      'Isuzu',
      'Mazda',
      'Mitsubishi',
      'Perodua',
      'Proton',
      'Peugeot',
    ],
    brandsLuxuryArray: [
      'MERCHEDES BENZ',
      'BMW',
      'AUDI',
      'VOLVO',
      'FERRARI',
      'BUGATTI',
      'Range Rover',
      'Lexus ',
      'Mini Cooper',
    ],
    paymentFormFooter: (
      <>
        Dengan meneruskan, saya memahami dan bersetuju dengan{' '}
        <RouterLink
          style={{
            color: '#003cc5',
            padding: '5px',
            borderRadius: '6px',
          }}
          target="_blank"
          to={'/my/inspection-terms-and-conditions'}
        >
          <strong>Terma Perkhidmatan</strong> dan <strong>Dasar Privasi</strong>
        </RouterLink>
        dari Wisedrive Technologies (M) Sdn. Bhd.
      </>
    ),
  },
  flexiPay: {
    header: (
      <h2>
        Sesuaikan Jaminan Kereta Anda dengan
        <br /> <span style={{ color: '#ff7858' }}>‘Flexi-Pay’</span> kami ..
      </h2>
    ),
    cardContent: [
      {
        color: '#003cc5',
        content: (
          <>
            <div className="flexi-quarterly">
              <div className="flexi-card-header">
                <h6 style={{ color: 'black' }}>
                  Pelan Pembayaran <br />
                  Suku Tahunan
                </h6>
                <div className="flexi-card-headright">
                  <p>Bermula dari</p>
                  <span style={{ fontFamily: 'matter' }}>
                    MYR
                    <p
                      style={{
                        fontSize: '22px',
                        fontFamily: 'matterSemibold',
                      }}
                    >
                      100
                    </p>
                  </span>
                </div>
              </div>
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    0-3 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Pelanggan</p>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Bayaran Bersama</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-label-p">Wisedrive</p>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Bayaran Balik</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    4-6 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Bayaran Bersama</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Bayaran Balik</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    7-9 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Bayaran Bersama</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Bayaran Balik</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div className="flexi-card-body">
                <div style={{ textAlign: 'center' }}>
                  <p className="card-duration-p">
                    10-12 <br /> Bulan
                  </p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">20%</p>
                  <p className="card-label-p">Bayaran Bersama</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <p className="card-percent-p">80%</p>
                  <p className="card-label-p">Bayaran Balik</p>
                </div>
              </div>
              <Divider className="divider-css" />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <a aria-label="" href="/my#contact-us">
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      fontSize: '18px',
                      fontFamily: 'matterMedium',
                      margin: '10px',
                      backgroundColor: '#e61f93',
                    }}
                  >
                    Hubungi Jualan
                  </Button>
                </a>
              </div>
            </div>
          </>
        ),
      },
      {
        content: (
          <div>
            <div className="flexi-halfCard-wrap">
              <div className="flexi-halfyearly">
                <div className="flexi-card-header">
                  <h6 style={{ color: 'black' }}>
                    Pelan Pembayaran <br />6 Bulan
                  </h6>
                  <div className="flexi-card-headright">
                    <p>Bermula dari</p>

                    <span style={{ fontFamily: 'matter' }}>
                      MYR
                      <p
                        style={{
                          fontSize: '22px',
                          fontFamily: 'matterSemibold',
                        }}
                      >
                        200
                      </p>
                    </span>
                  </div>
                </div>
                <div className="flexi-card-body">
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-duration-p">
                      0-6 <br /> Bulan
                    </p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-label-p">Pelanggan</p>
                    <p className="card-percent-p">10%</p>
                    <p className="card-label-p">Bayaran Bersama</p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-label-p">Wisedrive</p>
                    <p className="card-percent-p">90%</p>
                    <p className="card-label-p">Bayaran Balik</p>
                  </div>
                </div>
                <Divider className="divider-css" />
                <div className="flexi-card-body">
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-duration-p">
                      7-12 <br /> Bulan
                    </p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-percent-p">10%</p>
                    <p className="card-label-p">Bayaran Bersama</p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-percent-p">90%</p>
                    <p className="card-label-p">Bayaran Balik</p>
                  </div>
                </div>
                <Divider className="divider-css" />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <a aria-label="" href="/my#contact-us">
                    <Button
                      variant="contained"
                      sx={{
                        color: 'white',
                        fontSize: '18px',
                        fontFamily: 'matterMedium',
                        margin: '10px',
                        backgroundColor: '#950000',
                      }}
                    >
                      Hubungi Jualan
                    </Button>
                  </a>
                </div>
              </div>
              <div className="flexi-yearly">
                <div className="flexi-card-header">
                  <h6 style={{ color: 'black' }}>
                    Pelan Pembayaran <br />
                    Satu Tahun
                  </h6>
                  <div className="flexi-card-headright">
                    <p>Bermula dari</p>
                    <span style={{ fontFamily: 'matter' }}>
                      MYR
                      <p
                        style={{
                          fontSize: '22px',
                          fontFamily: 'matterSemibold',
                        }}
                      >
                        300
                      </p>
                    </span>
                  </div>
                </div>
                <div className="flexi-card-body">
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-duration-p">
                      0-12 <br /> Bulan
                    </p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-label-p">Pelanggan</p>
                    <p className="card-percent-p">10%</p>
                    <p className="card-label-p">Bayaran Bersama</p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <p className="card-label-p">Wisedrive</p>
                    <p className="card-percent-p">90%</p>
                    <p className="card-label-p">Bayaran Balik</p>
                  </div>
                </div>
                <Divider className="divider-css" />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <a aria-label="" href="/my#contact-us">
                    <Button
                      variant="contained"
                      sx={{
                        color: 'white',
                        fontSize: '18px',
                        fontFamily: 'matterMedium',
                        margin: '10px',
                        backgroundColor: '#202020',
                      }}
                    >
                      Hubungi Jualan
                    </Button>
                  </a>
                </div>
              </div>
            </div>
            <div className="flexi-note">
              <p>
                * Bayaran Bersama adalah peratusan amaun yang perlu dibayar oleh
                pelanggan untuk alat ganti waranti dalam tempoh pembayaran yang
                dinyatakan. Sila baca syarat waranti di{' '}
                <a aria-label="" href=" https://wisedrive.com">
                  {' '}
                  https://wisedrive.com
                </a>
                .
              </p>
              <p>
                ** Caj tunda dan pengendalian perlu dibayar secara berasingan
                dan akan dicaj berdasarkan jarak kereta ditunda.
              </p>
            </div>
          </div>
        ),
      },
    ],
  },
  comparePage: {
    header: 'Wisedrive Lebih Baik Daripada Pemeriksaan Kereta Terpakai Biasa',
    subTitle:
      'Nikmati ketenangan fikiran dengan pemeriksaan menyeluruh Wisedrive, laporan terperinci, dan jaminan pelanggan yang tiada tandingan bagi pembeli kereta terpakai.',
    wiseDrivePoints: {
      header: 'Kaedah Wisedrive',
      content: [
        {
          point: (
            <p>
              Memeriksa enjin, transmisi, elektrik, dan aspek mekanikal secara
              menyeluruh,
              <span className="highlet">
                memastikan semua bahagian kritikal dalam keadaan terbaik
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Menyediakan laporan pemeriksaan terperinci dengan
              <span className="highlet">
                gambar berkualiti tinggi dan diagnostik
              </span>
              untuk memberikan gambaran jelas tentang keadaan kereta.
            </p>
          ),
        },
        {
          point: (
            <p>
              Menggunakan
              <span className="highlet"> OBD-2, ECM, dan BCM </span> untuk
              memastikan semua sistem elektronik berfungsi dengan baik.
            </p>
          ),
        },
        {
          point: (
            <p>
              Menawarkan <span className="highlet">jaminan 6 bulan</span> dan
              <span className="highlet"> jaminan pemulangan</span>, memberikan
              ketenangan fikiran dan perlindungan kewangan.
            </p>
          ),
        },
        {
          point: (
            <p>
              Menawarkan <span className="highlet">jaminan selama 6 bulan</span>{' '}
              dan <span className="highlet">jaminan pembelian semula</span>,
              memberikan anda ketenangan fikiran dan jaminan kewangan.
            </p>
          ),
        },
      ],
    },
    comparePoints: {
      header: 'Pemeriksaan Biasa',
      content: [
        {
          point: (
            <p>
              Pemeriksaan menyeluruh tetapi
              <span className="highlet">
                {' '}
                mungkin kurang terperinci dalam beberapa aspek.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Laporan diberikan dengan diagnostik tetapi{' '}
              <span className="highlet">
                mungkin tidak selalu termasuk bukti visual.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Menggunakan alat diagnostik, tetapi
              <span className="highlet">
                pemeriksaan mungkin tidak menyeluruh atau konsisten.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Tidak menyediakan jaminan atau mengambil tanggungjawab, biasanya{' '}
              <span className="highlet">
                lebih singkat dan kurang menyeluruh.
              </span>
            </p>
          ),
        },
        {
          point: (
            <p>
              Jaminan yang diberikan
              <span className="highlet">
                {' '}
                biasanya lebih pendek dan kurang menyeluruh.
              </span>
            </p>
          ),
        },
      ],
    },
  },
  onlyWhatsApp: {
    header: (
      <>
        <h2 className="whatsapp-mobile-header">
          Tidak Berpihak, <br />
          Didorong Teknologi, <br />
          Fokus Pelanggan, Pemeriksaan Canggih
        </h2>
        <h2 className="whatsapp-header">
          Tidak Berpihak, Didorong Teknologi, Fokus Pelanggan, Pemeriksaan
          Canggih
        </h2>
        <p>
          Di WiseDrive, anda menikmati kualiti luar biasa dengan pemeriksaan
          yang tidak berpihak, teknologi canggih, fokus pelanggan, dan kaedah
          moden dalam menjalankan pemeriksaan kereta terpakai.
        </p>
      </>
    ),
    gradeCardsData: [
      {
        src: UnbiasedCustomer,
        header: 'Pemeriksaan Tidak Berpihak & Berfokus Pelanggan',
        content:
          'Pemeriksaan kami adalah telus sepenuhnya dan tidak berpihak, memberikan penilaian objektif yang hanya bertujuan memastikan kualiti dan kebolehpercayaan kenderaan tertinggi.',
      },
      {
        src: AiDrivenLogo,
        header: 'Dikuasakan AI - Analisis Bunyi Enjin',
        content:
          'WiseDrive menggunakan AI canggih untuk menganalisis bunyi enjin dengan membandingkan berjuta-juta titik data bagi kereta serupa di seluruh negara.',
      },
      {
        src: OBDScanner,
        header: 'Analisis Pengimbas OBD-2 Canggih',
        content:
          'Analisis Engine Control Module (ECM), Body Control Module (BCM), dan Transmission Control Module (TCM) kereta anda menggunakan pengimbas OBD-2 terkini.',
      },
    ],
  },
  brandGrade: {
    header: (
      <>
        <h2>Jaminan Setaraf Showroom untuk Kereta Anda</h2>
        <p className="grade-description">
          WiseDrive bekerjasama dengan pusat servis sah bagi semua jenama kereta
          yang dijual di India dan menyediakan perlindungan waranti yang luas di
          seluruh negara dengan kadar kelulusan tuntutan 98% dalam tempoh 24
          jam. Kami juga menawarkan bantuan tepi jalan dan sokongan waranti di
          seluruh India.
        </p>
      </>
    ),
    card1: {
      header: 'Komponen Elektrik',
      content:
        'Waranti Pendawaian Elektrik, Waranti Bateri, Waranti Infotainment, Waranti Lampu dan Mentol.',
    },

    card2: {
      header: 'Komponen Mekanikal',
      content: 'Suspensi, Penyerap hentakan, Lengan bawah.',
    },
    card3: {
      header: (
        <h6 style={{ color: 'white' }}>
          Enjin & <br />
          Komponen Transmisi
        </h6>
      ),
      content:
        'Semua komponen Enjin dan Transmisi dilindungi di bawah program Waranti Komprehensif WiseDrive. Transmisi automatik juga dilindungi.',
      content1:
        'Kami menyokong pemeriksaan kami dengan WARANTI PERCUMA untuk kereta anda.',
    },
    card4: {
      header: 'Bantuan Tepi Jalan',
      content:
        'Bantuan Tepi Jalan (RSA) termasuk dalam program Waranti Komprehensif.',
    },
    card5: {
      header: 'Waranti Penyaman Udara',
      content: 'Pemampat AC, Penyejuk AC, Pendawaian, Pendawaian Konduktor AC.',
    },
  },
  queryPage: {
    header: (
      <div>
        <p className="query-sub-header">Bagaimana Ia Berfungsi?</p>
        <h2 style={{ color: 'black' }}>
          Membeli Kereta Terpakai Tidak Pernah Sebegini{' '}
          <span style={{ color: '#003cc4' }}>Yakin</span>!
        </h2>
        <p style={{ color: 'black' }}>
          Hantar “HI” di WhatsApp ke +60 122559610 untuk membeli pelan
          pemeriksaan, menempah pemeriksaan, menjadualkan semula atau berbincang
          dengan pakar mengenai kereta anda.
          <strong> Kami hanya satu "Hi" sahaja untuk membantu anda.</strong>
        </p>
      </div>
    ),
    cardsData: [
      {
        img: one,
        headder: 'Beli Pelan Pemeriksaan',
        body: (
          <>
            <p>Pilih pakej pemeriksaan terbaik untuk kereta anda.</p>
            <p>
              Lakukan pemeriksaan sebelum membeli kereta dan dapatkan ketenangan
              fikiran selepas pembelian.
            </p>
          </>
        ),
      },
      {
        img: two,
        headder: 'Jadualkan Pemeriksaan',
        body: (
          <>
            <p>
              Jadualkan pemeriksaan secara dalam talian / WhatsApp atau hubungi
              kami di +60 122559610 pada bila-bila masa.
            </p>
            <p>
              Anda boleh menjadualkan pemeriksaan di mana-mana dalam bandar
              dengan mudah.
            </p>
          </>
        ),
      },
      {
        img: three,
        headder: 'Dapatkan Laporan dalam 2 Jam',
        body: (
          <>
            <p>
              Terima laporan pemeriksaan kereta anda dalam masa 2 jam selepas
              pemeriksaan selesai.
            </p>
            <p>
              Kami akan berkongsi laporan melalui pautan di WhatsApp yang boleh
              anda klik untuk melihatnya.
            </p>
          </>
        ),
      },
    ],
    advisory: (
      <>
        <p>
          Pakar kami akan menasihati anda mengenai semua isu berkaitan kereta
          dan membantu anda memilih kenderaan yang betul.
        </p>
        <p
          style={{
            color: '#003cc4',
            paddingTop: '0px',
            fontFamily: 'matterMedium',
          }}
        >
          Membeli kereta selepas Pemeriksaan Wisedrive menjamin Ketenangan
          Fikiran.
        </p>
      </>
    ),
  },
  pricePage: {
    header: (
      <>
        Kami menawarkan kualiti,{' '}
        <span style={{ fontFamily: 'matterThin' }}>
          dengan teknologi terbaik dan
          <br />
          pakar automotif dalam pemeriksaan kereta
        </span>
      </>
    ),
    subTitle:
      'Dipercayai oleh 200,000+ pelanggan untuk memeriksa kereta terpakai sebelum membeli',
    numberCardData: [
      {
        image: inspected,
        number: '200,000+',
        text: 'Pelanggan di seluruh India mempercayai kami sebelum membeli kereta terpakai',
      },
      {
        image: warranty,
        number: '75,000+',
        text: 'Pelanggan membeli waranti kami selepas pembelian untuk pemilikan tanpa kerumitan',
      },
      {
        image: kilometer,
        number: '80,00,000+',
        text: ' Kilometer yang telah dilalui oleh pelanggan dengan waranti WiseDrive',
      },
      {
        image: cities,
        number: '10+ Bandar',
        text: 'Dengan liputan di 10+ bandar, kami telah meliputi lebih 7000+ kod pos di India',
      },
      {
        image: customerSupport,
        number: 'Sokongan Pelanggan',
        text: 'Sokongan pelanggan kami tersedia 24/7 untuk sebarang pertanyaan berkaitan waranti',
      },
      {
        image: roadsideAssist,
        number: 'Bantuan Tepi Jalan',
        text: 'Tersekat di suatu tempat? Hubungi talian bantuan kami untuk mendapatkan bantuan dalam masa 30 minit',
      },
    ],
  },
  contactUsPage: {
    header: 'Hubungi Kami',
    subTitle:
      'WhatsApp, panggilan atau lengkapkan borang untuk mengetahui bagaimana Wisedrive dapat melindungi pelaburan anda dalam membeli kereta terpakai',
    email: 'support.my@wisedrive.com',
    mobile1: '+60 122559610',
    mobile2: '+60 122559610',
    dec1header: 'Sokongan Pelanggan',
    dec1Content: (
      <>
        <p style={{ paddingTop: '0px' }}>
          Wisedrive Technologies (M) Sdn. Bhd.
        </p>
        <p style={{ paddingTop: '0px' }}>Lot 2F, Jalan 215, Seksyen 51,</p>
        <p style={{ paddingTop: '0px' }}>Petaling Jaya, Selangor, </p>
        <p style={{ paddingTop: '0px' }}> Malaysia 46050</p>
      </>
    ),
    dec2Header: 'Maklum Balas dan Cadangan',
    dec2Content:
      'Kami menghargai maklum balas anda dan sentiasa berusaha untuk menambah baik Wisedrive. Input anda amat penting dalam membentuk masa depan pemeriksaan kereta terpakai di India.',
    formHeader: 'Hubungi Kami',
    phoneCode: 60,
    formSubtitle: 'Anda boleh menghubungi kami pada bila-bila masa',
    fromLableName: 'Nama Anda',
    fromLableEmail: 'E-mel Anda',
    fromLablePhone: 'Nombor Telefon',
    fromLableHelpText: 'Bagaimana kami boleh membantu?',
    formBtnText: 'Hantar Mesej',
    formTerms: (
      <>
        Dengan menghubungi kami, anda bersetuju dengan
        <span style={{ fontFamily: 'matterBold' }}> Terma dan Syarat </span> dan
        <span style={{ fontFamily: 'matterBold' }}> Dasar Privasi</span>
      </>
    ),
  },
  reviewPage: {
    header: 'Pengalaman dan Ulasan Pelanggan',
    subTitle:
      'Lihat bagaimana kepakaran kami memastikan keyakinan dalam setiap pembelian kenderaan terpakai',
    reviewsData: [
      {
        reviewer_name: 'Mallikarjun',
        car: 'Hyundai i10',
        description:
          'Perkhidmatan pemeriksaan Wisedrive benar-benar mengubah pengalaman saya! Saya melihat sebuah kereta terpakai yang kelihatan sempurna, tetapi pemeriksaan menyeluruh mereka mendedahkan beberapa masalah tersembunyi. Akhirnya, saya dapat merundingkan harga yang lebih baik terima kasih kepada laporan terperinci mereka. Sangat disyorkan!',
      },
      {
        reviewer_name: 'Nikita Sharma',
        car: 'Toyota Glanza',
        description:
          'Sebagai pembeli kereta pertama kali, saya berasa gementar untuk membeli kereta terpakai. Wisedrive menjadikan proses ini lebih mudah. Pemeriksa mereka menepati masa, profesional, dan menerangkan semuanya dalam istilah yang mudah difahami. Laporan itu sangat lengkap, dan saya berasa yakin dengan pembelian saya.',
      },
      {
        reviewer_name: 'Dilip Patel',
        car: 'Maruti Swift',
        description:
          'Wisedrive menyelamatkan saya daripada membeli kereta yang bermasalah! Kereta itu kelihatan hebat di luar, tetapi pemeriksa menemui beberapa masalah mekanikal. Perkhidmatan mereka benar-benar berbaloi jika anda mahu mengelakkan diri daripada ditipu semasa membeli kereta terpakai.',
      },
      {
        reviewer_name: 'Dharmesh Soni',
        car: 'MG Hector',
        description:
          'Saya telah menggunakan Wisedrive dua kali, dan kedua-duanya mereka memberikan perkhidmatan yang luar biasa. Pemeriksa mereka sangat berpengetahuan dan tidak tergesa-gesa dalam proses pemeriksaan. Laporan terperinci mereka membantu saya membuat keputusan yang tepat. Perkhidmatan yang wajib digunakan bagi pembeli kereta terpakai!',
      },
      {
        reviewer_name: 'Swati Gorakh',
        car: 'Skoda Octavia',
        description:
          'Sangat kagum dengan Wisedrive! Pemeriksa mereka sangat teliti dan menemui beberapa masalah kecil yang saya tidak sedari. Malah, penjual mengakui terdapat beberapa perkara kecil yang mereka tidak nyatakan. Saya berasa lebih yakin dengan pembelian saya selepas menggunakan perkhidmatan ini.',
      },
      {
        reviewer_name: 'Rudra Gowda',
        car: 'Hyundai Venue',
        description:
          'Wisedrive adalah perkhidmatan yang mesti digunakan jika anda membeli kereta terpakai. Laporan pemeriksaan mereka sangat terperinci dan mudah difahami. Pemeriksa mereka memeriksa setiap aspek dengan teliti. Saya sangat gembira kerana menggunakan perkhidmatan mereka sebelum membuat pembelian.',
      },
      {
        reviewer_name: 'Chetana',
        car: 'Volkswagen Polo',
        description:
          'Pada mulanya saya ragu-ragu untuk melakukan pemeriksaan, tetapi saya sangat bersyukur kerana melakukannya! Wisedrive menemui masalah dengan transmisi yang boleh menyebabkan saya menanggung kos yang tinggi. Perkhidmatan mereka sangat berkualiti dan benar-benar berbaloi untuk dilaburkan.',
      },
      {
        reviewer_name: 'Gomti',
        car: 'Toyota Fortuner',
        description:
          'Saya sentiasa ragu-ragu untuk membeli kereta terpakai, tetapi Wisedrive menjadikan proses ini bebas tekanan. Pemeriksaan mereka sangat menyeluruh, dan laporan yang diberikan membuatkan saya yakin bahawa saya membuat pembelian yang baik. Sangat disyorkan kepada sesiapa yang ingin membeli kereta terpakai!',
      },
      {
        reviewer_name: 'Naduvinahalli Kariyappa',
        car: 'Ford Endeavour',
        description:
          'Pemeriksa dari Wisedrive sangat mesra, profesional, dan teliti. Laporan mereka merangkumi semua maklumat yang saya perlukan, dan perkhidmatan pelanggan mereka sangat baik. Saya berasa lebih yakin kerana mempunyai semua maklumat sebelum membeli.',
      },
      {
        reviewer_name: 'Rajat Chaudhry',
        car: 'Mahindra Scorpio',
        description:
          'Perkhidmatan pemeriksaan Wisedrive sangat hebat! Mereka menyediakan laporan terperinci yang membantu saya merundingkan harga yang lebih baik. Pemeriksa mereka sangat berpengetahuan dan menjawab semua soalan saya. Saya pasti akan menggunakan perkhidmatan mereka lagi untuk pembelian kereta di masa hadapan.',
      },
    ],
    buttonText: '1500+ ulasan di Google',
  },
  faqPage: {
    header: 'Soalan Lazim',
    subtitle:
      'Semua yang anda perlu tahu tentang produk dan pengebilan. Tidak menemui jawapan yang anda cari? Hubungi Kami',
    faqData: [
      {
        question:
          'Apakah perkhidmatan yang ditawarkan oleh Wisedrive untuk pemeriksaan kereta terpakai?',
        answer:
          'Wisedrive menawarkan pemeriksaan kereta terpakai yang menyeluruh, merangkumi komponen penting seperti enjin, transmisi, brek, dan sistem elektrik.',
      },
      {
        question: 'Bagaimana saya boleh menempah pemeriksaan kereta?',
        answer:
          'Anda boleh menempah pemeriksaan melalui laman web atau aplikasi mudah alih kami dengan memilih pakej pilihan anda dan menetapkan temujanji.',
      },
      {
        question:
          'Apa yang termasuk dalam pemeriksaan kereta terpakai Wisedrive?',
        answer:
          'Pemeriksaan kami merangkumi lebih 200 titik semakan, termasuk sistem mekanikal, elektrik, dan keselamatan.',
      },
      {
        question: 'Bagaimana proses pemeriksaan berfungsi?',
        answer:
          'Juruteknik bertauliah akan memeriksa kereta anda di lokasi anda atau bengkel rakan kongsi, kemudian memberikan laporan terperinci.',
      },
      {
        question: 'Berapa lama pemeriksaan kereta biasanya mengambil masa?',
        answer:
          'Pemeriksaan biasanya mengambil masa kira-kira 1-2 jam, bergantung kepada keadaan kenderaan dan pakej yang dipilih.',
      },
      {
        question:
          'Bolehkah saya meminta pemeriksaan untuk sebarang jenis kenderaan?',
        answer:
          'Kami memeriksa kebanyakan jenis kenderaan, termasuk sedan, SUV, dan trak.',
      },
      {
        question: 'Berapakah kos pemeriksaan kereta terpakai?',
        answer:
          'Kos berbeza mengikut pakej yang dipilih. Maklumat harga terperinci boleh didapati di laman web kami.',
      },
      {
        question: 'Apakah jenis waranti yang ditawarkan oleh Wisedrive?',
        answer:
          'Kami menawarkan pelbagai pelan waranti yang meliputi aspek berbeza penyelenggaraan dan pembaikan kenderaan.',
      },
      {
        question:
          'Bagaimana saya boleh membeli waranti dengan pemeriksaan saya?',
        answer:
          'Anda boleh menambah waranti ke dalam pakej pemeriksaan semasa proses tempahan di laman web atau aplikasi kami.',
      },
      {
        question: 'Apakah yang dilindungi oleh waranti Wisedrive?',
        answer:
          'Liputan berbeza mengikut pelan tetapi secara amnya termasuk komponen utama seperti enjin, transmisi, dan sistem elektrik.',
      },
      {
        question: 'Adakah terdapat pengecualian dalam liputan waranti?',
        answer:
          'Ya, beberapa pengecualian terpakai. Sila rujuk terma dan syarat waranti tertentu untuk butiran lanjut.',
      },
      {
        question:
          'Bagaimana saya boleh menuntut pembaikan waranti dengan Wisedrive?',
        answer:
          'Hubungi pasukan sokongan kami untuk membuat tuntutan, dan kami akan membimbing anda melalui proses tersebut serta mengarahkan anda ke pusat servis yang sah.',
      },
      {
        question:
          'Bolehkah saya memindahkan waranti saya kepada pemilik baharu jika saya menjual kereta saya?',
        answer:
          'Ya, waranti boleh dipindahkan kepada pemilik baharu, memastikan liputan berterusan.',
      },
      {
        question: 'Berapa lamakah tempoh sah waranti anda?',
        answer:
          'Tempoh waranti berbeza mengikut pakej dan boleh berkisar antara 6 bulan hingga beberapa tahun.',
      },
    ],
  },
  footerPage: {
    subTitle:
      'Wisedrive ialah penyedia pemeriksaan kereta terpakai dan waranti kereta terpakai pertama di India dengan AI canggih dalam Industri Waranti Automotif. Wisedrive menerajui industri pemeriksaan kereta terpakai dengan kehadiran di 30 bandar di India.',
    footerLinkProducts: {
      header: 'Produk',
      links: [
        {
          link: '/my#inspection-plans',
          label: 'Inspeksi Mobil',
          type: 'anchor',
        },
        {
          link: '/my#inspection-plans',
          label: 'Garansi Mobil Bekas',
          type: 'anchor',
        },
        {
          link: '/my',
          label: 'Servis & Perawatan Mobil',
          type: 'link',
        },
        {
          link: '/',
          label: 'Perbaikan & Perawatan Mobil',
          type: 'link',
        },
        {
          link: '#inspection-plans',
          label: 'Inspeksi Mobil Mewah',
          type: 'anchor',
        },
        {
          link: '/my#inspection-plans',
          label: 'Inspeksi Mobil Bekas',
          type: 'anchor',
        },
      ],
    },
    footerLinkCompany: {
      header: 'Syarikat',
      links: [
        {
          link: '/my/about-wisedrive',
          label: 'Tentang Kami',
          type: 'link',
        },
        {
          link: '/my#how-it-works',
          label: 'Bagaimana ia berfungsi?',
          type: 'anchor',
        },
        {
          link: '/my#contact-us',
          label: 'Hubungi Kami',
          type: 'anchor',
        },
        {
          link: '/my',
          label: 'Lawati Kami',
          type: 'link',
        },
      ],
    },
    footerLinkResources: {
      header: 'Sumber',
      links: [
        {
          link: '/my',
          label: 'Blog',
          type: 'link',
        },
        {
          link: '/my',
          label: 'Media Sosial',
          type: 'link',
        },
        {
          link: '/my',
          label: 'Surat Berita',
          type: 'link',
        },
        {
          link: '/my#contact-us',
          label: 'Sokongan',
          type: 'anchor',
        },
        {
          link: '/my#contact-us',
          label: 'Pusat Bantuan',
          type: 'anchor',
        },
      ],
    },
    footerLinkPolicies: {
      header: 'Dasar & Terma',
      links: [
        {
          link: '/my/inspection-terms-and-conditions',
          label: 'Terma dan Syarat Pemeriksaan',
          type: 'link',
        },
        {
          link: '/my/warrantyPolicy',
          label: 'Terma dan Syarat Waranti',
          type: 'link',
        },
        {
          link: '/my/cancellation_refund_policy',
          label: 'Dasar Pembatalan & Bayaran Balik',
          type: 'link',
        },
        {
          link: '/my/terms-and-conditions',
          label: 'Terma dan Syarat',
          type: 'link',
        },
        {
          link: '/my/privacy',
          label: 'Dasar Privasi',
          type: 'link',
        },
      ],
    },
    footerCopyRight:
      '© Wisedrive Technologies (M) Sdn. Bhd. All rights reserved 2025',
    footerCopyRightMobile: (
      <>
        © Wisedrive Technologies (M) Sdn. Bhd. <br />
        All rights reserved 2025
      </>
    ),
  },
  aboutUsPage: {
    header: 'Tentang Kami',
    leftHeader: (
      <>
        Misi kami adalah <br />
        untuk memastikan <br /> ketenangan fikiran <br />
        kepada pembeli kereta terpakai
      </>
    ),
    rightContent:
      'WiseDrive ialah syarikat Generative AI pertama di India yang menyediakan perkhidmatan pemeriksaan kereta terpakai yang inovatif serta perkhidmatan jaminan lanjutan bertaraf bilik pameran untuk kereta terpakai di India. Kami telah bekerjasama dengan perkhidmatan yang diberi kuasa OEM untuk menyediakan perkhidmatan terbaik kepada pelanggan jaminan kami selepas pembelian, memastikan ketenangan fikiran. Kami menawarkan pemeriksaan pihak ketiga yang bebas dan tidak berat sebelah dengan AI terbaik dalam industri automotif serta pemeriksaan kereta terpakai yang telus dan tepat.',
    cardContent: [
      {
        header: '200,000+',
        description: 'Pemeriksaan Kereta Terpakai',
        subTitle: 'Pelanggan yang telah membeli perkhidmatan pemeriksaan kami',
      },
      {
        header: '75,000+',
        description: 'Jaminan Kereta Terpakai',
        subTitle: 'Pelanggan jaminan aktif di India',
      },
      {
        header: '8,000,000+',
        description: 'Kepercayaan terhadap WiseDrive',
        subTitle: 'Kilometer yang telah dilalui oleh pelanggan gembira kami',
      },
      {
        header: '20 Bandar',
        description: '7000+ Poskod',
        subTitle:
          'Kami menyediakan perkhidmatan pemeriksaan di 20 bandar di India',
      },
    ],
    headerDesc: 'Misi Kami',
    header2: 'Bagaimana kami memastikan ketenangan fikiran?',
    subTitle:
      'Kami memulakan dengan memeriksa kereta anda sebelum anda membelinya',
    missionLeftContent:
      'WiseDrive komited untuk melindungi pembeli kereta terpakai daripada risiko membeli kenderaan yang tidak boleh dipercayai. Proses kami bermula dengan pemeriksaan menyeluruh bagi setiap kenderaan untuk memastikan ia memenuhi standard kualiti yang ketat. Hanya kenderaan yang lulus pemeriksaan akan menerima pengiktirafan WiseDrive. Sebagai sebahagian daripada komitmen kami terhadap kepuasan pelanggan, setiap kereta yang diluluskan akan disertakan dengan jaminan percuma selama 60 hari. Perlindungan awal ini memberikan pembeli ketenangan fikiran dan keyakinan dalam pembelian mereka.',
    missionLeftHeader: 'Bagaimana ia berfungsi:',
    missionLeftPoints: [
      'Pemeriksaan Menyeluruh: Setiap kereta diperiksa secara terperinci untuk mengenal pasti dan menangani sebarang isu yang berpotensi.',
      'Jaminan Percuma 60 Hari: Kenderaan yang diluluskan akan menerima perlindungan ini secara percuma, memberikan pembeli perlindungan segera daripada pembaikan yang tidak dijangka.',
      'Pilihan Jaminan Lanjutan: Selepas 60 hari pertama, pelanggan mempunyai pilihan untuk melanjutkan jaminan mereka dan terus menikmati perlindungan.',
    ],
    missionRightContent:
      'Selain menawarkan perlindungan semasa pembelian, modul perkhidmatan dan penyelenggaraan WiseDrive memastikan kesihatan kenderaan dalam jangka panjang. Melalui platform kami, pelanggan boleh menjejaki sejarah penyelenggaraan kenderaan mereka, menerima peringatan tentang perkhidmatan yang akan datang, dan juga menempah janji temu dengan penyedia perkhidmatan yang dipercayai.',
    missionRightHeader: 'Ciri penyelenggaraan kami termasuk:',
    missionRightPoints: [
      'Peringatan Servis: Jangan terlepas tugas penyelenggaraan penting seperti penukaran minyak enjin, penjajaran tayar atau pemeriksaan brek.',
      'Tempahan Mudah: Jadualkan janji temu penyelenggaraan terus melalui platform dengan pusat servis yang telah disahkan.',
      'Penjejakan Sejarah Penyelenggaraan: Simpan semua rekod di satu tempat untuk pengurusan yang lebih baik dan meningkatkan nilai jualan semula.',
    ],
    missionRightFooter:
      'Dengan menggabungkan pemeriksaan menyeluruh, perlindungan jaminan, dan sokongan penyelenggaraan berterusan, WiseDrive bukan sahaja membantu pembeli mengelakkan kenderaan bermasalah tetapi juga memastikan kenderaan mereka sentiasa dalam keadaan terbaik, meningkatkan keselamatan dan kebolehpercayaan dalam jangka panjang.',
  },
  inspectionTerms: {
    header: 'Terma & Syarat Pemeriksaan',
    contentArray: [
      {
        data: (
          <>
            <strong>Kami/Kita dan Kami </strong>
            bermaksud Wisedrive Technologies (M) Sdn. Bhd. Limited
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Perjanjian </strong>bermaksud perjanjian antara Wisedrive
            dan Pelanggan di mana Wisedrive bersetuju untuk mengatur agar
            seorang Pemeriksa menjalankan Pemeriksaan selaras dengan terma dan
            syarat ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Yuran Pembatalan </strong>bermaksud jumlah yang perlu
            dibayar oleh Pelanggan seperti yang dinyatakan dalam terma dan
            syarat ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pelanggan/Anda </strong>bermaksud pelanggan Wisedrive yang
            membuat tempahan untuk Pemeriksaan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Yuran </strong>bermaksud jumlah yang perlu dibayar oleh
            Pelanggan kepada Wisedrive untuk Pemeriksaan seperti yang dinyatakan
            di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pemeriksaan </strong>bermaksud pemeriksaan visual audio dan
            luaran serta pandu uji yang dilakukan oleh seorang Pemeriksa bagi
            pihak Wisedrive untuk Pelanggan selaras dengan terma dan syarat ini.
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive menyediakan beberapa kategori Pemeriksaan yang berbeza,
            setiap satu melibatkan semakan yang berbeza. Butiran mengenai
            kategori pemeriksaan yang berlainan dan semakan yang terlibat boleh
            didapati di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            &nbsp; atau dengan menghubungi +60 122559610. Pengesahan kategori
            Pemeriksaan yang dipilih oleh Pelanggan akan dilakukan pada
            Kenderaan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pemeriksa </strong>merujuk kepada pemeriksa bertauliah yang
            menjalankan Pemeriksaan bagi pihak Wisedrive. Pemeriksa adalah
            tertakluk kepada ketersediaan dan boleh digantikan dengan ejen pihak
            ketiga yang bersesuaian.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Laporan </strong>bermaksud laporan bertulis yang dihasilkan
            oleh Pemeriksa sebagai sebahagian daripada Pemeriksaan, yang
            merangkumi nama dan alamat Pelanggan, butiran pendaftaran Kenderaan
            yang diperiksa serta lokasinya, sama ada Kenderaan tersebut lulus
            atau gagal dalam Pemeriksaan, senarai semakan yang dilakukan
            (bergantung kepada jenis Pemeriksaan yang diminta oleh Pelanggan)
            dan ringkasan mana-mana aspek kebimbangan yang perlu diberi
            perhatian oleh Pelanggan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Senarai Semakan Laporan </strong>bermaksud senarai aspek
            yang akan atau telah diperiksa oleh Pemeriksa sebagai sebahagian
            daripada Pemeriksaan Fizikal, yang boleh didapati di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Kenderaan </strong>bermaksud kenderaan yang mana Pelanggan
            memerlukan Pemeriksa untuk menjalankan Pemeriksaan.
          </>
        ),
      },
    ],
    subHeader: 'Umum',
    listContent: [
      'Pemeriksaan disediakan berdasarkan pemeriksaan visual dan luaran sahaja dan terhad kepada bahagian dan/atau item yang dikenal pasti dalam Laporan. Pemeriksaan tidak melibatkan pembongkaran atau gangguan terhadap mana-mana struktur, komponen atau mekanisme dalaman. Pemeriksa akan menjalankan ujian jalan ke atas Kenderaan dan menghasilkan Laporan. Terdapat bahagian tertentu dalam Kenderaan yang tidak akan diperiksa. Anda harus membaca Senarai Semakan Laporan dengan teliti untuk melihat apa yang tidak akan diperiksa.',
      'Salinan Laporan akan dihantar kepada Anda melalui e-mel ke alamat e-mel yang Anda berikan semasa membuat tempahan Pemeriksaan. Disebabkan oleh sifat internet dan perisian perlindungan virus yang digunakan oleh penyedia perkhidmatan internet Anda atau yang dimuatkan ke komputer Anda, mungkin dalam sesetengah kes Laporan tidak dapat dihantar melalui e-mel. Sekiranya Anda tidak menerima Laporan Anda dalam tempoh 24 jam selepas Pemeriksaan Kenderaan Wisedrive dijalankan, Anda mesti memaklumkan kepada Kami secepat mungkin supaya Kami boleh menghantar semula Laporan Anda. Kami tidak akan bertanggungjawab kepada Anda atas sebarang kegagalan untuk menghantar Laporan sekiranya kegagalan tersebut berada di luar kawalan munasabah Kami.',
      'Item yang disenaraikan dalam Senarai Semakan Laporan sebagai bahagian/item yang perlu diperiksa, tetapi tidak dapat diakses dengan mudah pada Kenderaan, tidak akan diperiksa. Dalam keadaan sedemikian, Kami tidak mempunyai kewajipan untuk memeriksa dan/atau melaporkan bahagian/item tersebut dan Pemeriksa akan menandakan bahagian yang berkaitan dalam Laporan dengan sewajarnya.',
      'Kenderaan harus dalam keadaan bersih bagi memastikan Pemeriksa dapat melihat dan melaporkan secara tepat mengenai bahagian kenderaan yang diperiksa. Jika kenderaan tidak bersih, Pemeriksa berhak untuk tidak memberi komen mengenai bahagian tersebut dan akan menandakan Senarai Semakan Laporan dengan sewajarnya. Dalam kes ini, Yuran Laporan tetap perlu dibayar sepenuhnya.',
    ],
    subHeader3: (
      <>
        <strong>Ujian Jalan Raya </strong>
      </>
    ),
    listContent2: [
      <>
        Untuk membolehkan Pemeriksa kami menjalankan Ujian Jalan Raya ke atas
        Kenderaan, Anda mesti memastikan bahawa kenderaan mengandungi jumlah
        yang mencukupi:
        <br /> (a) Air; <br /> (b) Minyak;
        <br /> (c) Petrol.
      </>,
      'Ujian jalan raya dijalankan dalam kawasan sekitar Pemeriksaan. Jika:',
      'Kenderaan berada dalam keadaan tidak selamat untuk dipandu atau mengandungi jumlah minyak, air dan/atau petrol yang tidak mencukupi',
      'Pelanggan tidak dapat mengesahkan bahawa Kenderaan mempunyai sijil kecergasan yang sah dan oleh itu ujian jalan raya tidak dapat dijalankan semasa Pemeriksaan',
      'Bayaran bagi Pemeriksaan masih perlu dibayar sepenuhnya dan bayaran tambahan akan dikenakan untuk sebarang ujian jalan raya susulan yang Anda minta Kami jalankan.',
      'Pelaksanaan ujian jalan raya tidak bermaksud Pemeriksa kami telah melihat sijil kecergasan yang sah.',
      'Mendapatkan kebenaran yang diperlukan serta akses ke Kenderaan adalah tanggungjawab Pelanggan.',
      'Pelanggan mesti memastikan bahawa penyediaan yang betul telah dibuat (termasuk mendapatkan sebarang kebenaran yang diperlukan daripada pemilik Kenderaan) untuk Pemeriksaan dijalankan di premis bengkel atau di kawasan luar jalan dengan permukaan rata, keras dan kering.',
      'Pemeriksa kami memerlukan ruang yang mencukupi untuk berjalan mengelilingi Kenderaan dan membuka semua pintu sepenuhnya. Pemeriksa kami juga perlu mempunyai ruang yang mencukupi untuk meletakkan kenderaannya berhampiran lokasi Pemeriksaan.',
      'Pencahayaan dalaman berkualiti tinggi atau cahaya matahari yang mencukupi (jika Pemeriksaan dilakukan di luar) mesti disediakan di lokasi Pemeriksaan. Kami tidak dapat memeriksa Kenderaan dalam pencahayaan yang lemah atau dalam keadaan gelap.',
    ],
    subHeader4: 'Bayaran dan Pembatalan',
    listContent3: [
      'Bayaran mesti dibuat semasa tempahan Pemeriksaan.',
      <>
        Kami berhak untuk menolak menjalankan Pemeriksaan atau mengeluarkan
        Laporan untuk sebarang kenderaan: yang tidak boleh diakses oleh
        Pemeriksa dengan wajar; atau yang kelihatan kepada Pemeriksa sebagai:
        <br /> (a) bukan keluaran standard (contohnya, tetapi tidak terhad
        kepada, kereta kit);
        <br /> (b) telah diubah suai atau tidak digunakan secara kerap
        (contohnya, menunjukkan tanda-tanda kakisan berlebihan pada bahagian
        bergerak akibat dibiarkan terlalu lama dan boleh menyebabkan Kenderaan
        tidak selamat untuk dipandu tanpa pembaikan);
        <br /> (c) tidak selamat untuk dipandu atau berada dalam keadaan tidak
        layak di jalan raya.
      </>,
      'Mana-mana keadaan yang dirujuk dalam Terma & Syarat ini.',
      'Di mana Pelanggan gagal memastikan penyediaan yang betul untuk Pemeriksaan dijalankan, seperti yang diperlukan.',
      'Di mana Pelanggan telah memberikan maklumat yang salah atau tidak lengkap yang menghalang Kami daripada menjalankan Pemeriksaan dan Anda mengakui bahawa dalam keadaan sedemikian Kami berhak untuk menganggap Perjanjian sebagai ditamatkan dan menyimpan Bayaran sepenuhnya.',
      'Jika Anda ingin Kami menjalankan Pemeriksaan lain, Anda perlu membuat bayaran tambahan semasa tempahan baru.',
      'Anda berhak untuk membatalkan Pemeriksaan dan menerima pemulangan penuh Bayaran jika pembatalan dibuat sekurang-kurangnya 24 jam sebelum Pemeriksaan dijadualkan. Setelah Pemeriksaan dijalankan, tiada pemulangan bayaran akan diberikan.',
      'Untuk membatalkan Pemeriksaan, Anda mesti memaklumkan Pasukan Sokongan Pelanggan kami tentang keputusan Anda dengan menghantar e-mel ke support.my@wisedrive.com atau menghubungi +60 122559610, Isnin hingga Jumaat dari jam 9 pagi hingga 5 petang.',
      'Bagi membolehkan kami mencari tempahan Anda, Anda perlu memberikan nama, alamat, nombor telefon dan nombor rujukan tempahan (seperti yang diberikan dalam pengesahan tempahan Anda) bersama permohonan pembatalan Anda.',
    ],
    subHeader5: 'Aduan',
    listContent4: [
      'Jika Anda mempunyai aduan atau tidak berpuas hati dengan sebarang Pemeriksaan yang telah dijalankan, sila hubungi Kami di +60 122559610 secepat mungkin. Kami mungkin perlu menjalankan pemeriksaan semula ke atas Kenderaan untuk menangani aduan tersebut, dan Anda bersetuju untuk membenarkan Kami berbuat demikian.',
      'Tiada pembaikan boleh dilakukan atau mana-mana bahagian kenderaan diganti sebelum Pemeriksaan semula dijalankan oleh Kami. Jika pembaikan kecemasan diperlukan bagi memastikan Kenderaan selamat digunakan dan kemudian menjadi subjek aduan kepada Kami, Anda mesti memastikan aduan dibuat kepada Kami (termasuk pemberitahuan mengenai keperluan pembaikan kecemasan) dalam tempoh yang munasabah selepas masalah ditemui. Mana-mana bahagian yang rosak atau haus yang telah dibaiki atau diganti mesti disimpan untuk pemeriksaan lanjut oleh Kami. Kami tidak akan bertanggungjawab dalam apa jua keadaan terhadap kos pembaikan atau penggantian bahagian tanpa persetujuan bertulis terdahulu daripada Kami.',
      'Kami berhak untuk memerlukan seorang lagi Pemeriksa Kami untuk menjalankan Pemeriksaan semula ke atas mana-mana Kenderaan atas perbelanjaan Kami sendiri jika dianggap perlu untuk menangani sebarang aduan. Anda juga dikehendaki membenarkan Pemeriksa Kami menjalankan Pemeriksaan semula tersebut mengikut terma dan syarat ini. Kami akan memberikan pendapat kedua yang tidak berat sebelah terhadap Laporan awal yang dikeluarkan.',
    ],
    subHeader6: 'Perkara di luar kawalan munasabah Kami',
    listContent5: [
      'Kami tidak akan bertanggungjawab terhadap sebarang kelewatan atau ketidakupayaan untuk menjalankan Pemeriksaan akibat kejadian atau keadaan di luar kawalan munasabah Kami. Kami akan mengambil langkah untuk mengurangkan kesannya sekiranya boleh.',
      'Wisedrive hanya akan bertanggungjawab kepada Pelanggan (dan bukan kepada mana-mana pihak lain) sekiranya Wisedrive gagal menjalankan Pemeriksaan mengikut terma dan syarat ini. Tanpa mengehadkan perkara di atas, Anda mengakui bahawa Wisedrive atau Pemeriksa tidak akan bertanggungjawab kepada Anda atau mana-mana pihak lain atas sebarang liabiliti, kerugian, kerosakan, tuntutan, prosiding, kos atau perbelanjaan (secara kolektif dirujuk sebagai "Kerugian") yang dialami atau ditanggung dalam mana-mana keadaan berikut:',
      'Kerugian tersebut bukan akibat yang boleh diramalkan secara munasabah daripada sebarang pelanggaran (Kerugian dianggap boleh diramalkan jika ia boleh dijangkakan oleh Anda dan Kami pada masa Pemeriksaan Kenderaan dilakukan).',
      'Kerugian tersebut tidak disebabkan secara langsung oleh pelanggaran terma dan syarat ini oleh Kami atau Pemeriksa.',
      'Kerugian tersebut melibatkan kerugian perniagaan atau lain-lain kerugian kepada pelanggan yang bukan pengguna.',
      'Kerugian tersebut meningkat akibat daripada pelanggaran mana-mana terma dan syarat ini oleh Anda.',
      'Tiada apa-apa dalam dokumen ini yang akan menjejaskan hak statutori pengguna di bawah mana-mana undang-undang yang berkenaan.',
    ],
    subHeader7: 'Penguatkuasaan terma',
    listContent6: [
      'Setiap klausa dalam terma ini beroperasi secara berasingan. Jika mana-mana mahkamah atau pihak berkuasa yang berkaitan memutuskan bahawa mana-mana daripadanya adalah tidak sah, klausa yang selebihnya akan tetap berkuat kuasa sepenuhnya.',
      'Perjanjian ini adalah antara Anda dan Wisedrive. Tiada pihak lain yang mempunyai hak untuk menguatkuasakan mana-mana terma dalam Perjanjian ini. Kita juga tidak perlu mendapatkan persetujuan mana-mana pihak untuk membuat sebarang perubahan kepada terma ini.',
    ],
    subHeader8: 'Nasihat berkaitan Laporan',
    listContent7: [
      'Anda dinasihatkan agar membincangkan penemuan dalam Laporan dengan penjual sebelum membuat keputusan untuk membeli Kenderaan. Jika Anda belum melihat Kenderaan secara peribadi, Anda mesti memastikan bahawa keadaan kosmetik dan spesifikasi Kenderaan adalah memuaskan dan sesuai dengan keperluan serta jangkaan Anda. Kami mencadangkan agar Anda melihat dan memandu sendiri Kenderaan sebelum membuat keputusan pembelian.',
    ],
  },
  warrantyTerms: {
    header: 'Pengecualian Waranti dan Terma & Syarat',
    subHeader1: 'Penerangan Waranti',
    point: `Pakej Perkhidmatan Inklusif dan/atau Pembaikan Inklusif dijalankan seperti yang dinyatakan dalam butiran pelan. Pelanggan secara sukarela memilih untuk membeli pakej Perkhidmatan Inklusif/Pembaikan Inklusif, sebuah produk nilai tambah yang ditawarkan oleh Wisedrive Technologies (M) Sdn. Bhd. secara eksklusif untuk kegunaan peribadi sahaja. Untuk menikmati faedah tambahan dengan bayaran kos tambahan adalah tertakluk kepada budi bicara pelanggan. Oleh itu, Wisedrive Technologies (M) Sdn. Bhd. berniat untuk menjual Pelan Penyelenggaraan Perkhidmatan kepada pelanggan melalui pengedar kereta terpakai yang sah dan dalam talian melalui ${(
      <a aria-label="" href="https://www.wisedrive.com">
        https://www.wisedrive.com
      </a>
    )}, tertakluk kepada Terma dan Syarat yang disebutkan di bawah. Pelanggan dengan ini mengesahkan bahawa beliau telah memahami sepenuhnya dan menerima perkara yang sama. Perkhidmatan dan Pembaikan Inklusif hanya terpakai untuk produk spesifikasi kilang asal.`,
    subHeader2: 'Tempoh Liputan Pakej (Untuk Semua Pakej):',
    durationList: [
      'Pakej bermula pada tarikh permulaan waranti yang ditetapkan untuk kenderaan seperti yang dinyatakan pada tarikh Pengaktifan pakej',
      'Kos perkhidmatan dan pembaikan yang dilakukan sebelum pembelian pakej tidak dilindungi atau tidak boleh dikembalikan',
      'Pakej tamat apabila had masa tercapai, yang sah untuk sama ada 6 bulan (180 hari) atau 12 bulan (365 hari), atau sehingga kenderaan mencapai 10,000 kilometer, (mana yang berlaku terlebih dahulu). Berdasarkan pakej yang dilanggan oleh pelanggan.',
      'Sekiranya kereta diluluskan di bawah tempoh penyejukan, syarat KMS & Hari tempoh penyejukan yang disebutkan harus diselesaikan sebelum tuntutan waranti boleh dibuat.',
    ],
    subHead3: 'Pengecualian',
    subtitleExclusions:
      "(Perkhidmatan berikut tidak termasuk dalam 'Pembaikan Inklusif')",
    exclusionsList: [
      'Bahan api dan pencemaran dalam sistem bahan api serta kerosakan berikutan. Kerosakan pada kemasan cat, badan, penutup, dan panel.',
      'Semua jenis kecacatan kaca dan/atau kerosakan akibat kemalangan (contohnya cermin, tingkap, rumah lampu hadapan, distorsi optik, tompokan, kabur, dll).',
      'Tayar, berat imbangan roda, dan kerosakan roda.',
      'Pembaikan yang menjadi tanggungjawab pengguna kenderaan (kerosakan enjin akibat kekurangan minyak, pertukaran minyak yang tertangguh, dan penyertaan dalam acara perlumbaan).',
      'Kerosakan hidrostatik, banjir dan/atau kerosakan akibat kemalangan.',
      'Kerosakan hidrostatik, banjir dan/atau kerosakan akibat kemalangan.',
      'Mentol, dll (kecuali lampu LED dan Xenon).',
      'Kerosakan berkaitan bau dan pengumpulan debu seperti muncung sistem pencuci pengelap, dll.',
      'Pembaikan atau hasil yang disebabkan oleh penggunaan aksesori asli/bukan asli.',
      'Kerusakan dan kerosakan umum yang disebabkan oleh kuasa luar, perlanggaran, banjir, kakisan, kebakaran, kecurian, gigitan tikus, atau sebarang kerosakan berikutan faktor luar dan tidak berkaitan dengan sebarang kecacatan pembuatan tidak dilindungi di bawah pelan penyelenggaraan prabayar Wisedrive.',
      'Semua penyesuaian seperti Penyelarasan Roda, Penyeimbangan, Penyelarasan Lampu Hadapan, dll tidak dilindungi di bawah pelan penyelenggaraan prabayar Wisedrive.',
      'Masalah yang berkaitan dengan badan dan permukaan cat tidak dilindungi di bawah pelan penyelenggaraan prabayar Wisedrive. Bahagian berkaitan penyelenggaraan berkala seperti pelincir, penapis, cecair brek, cecair stereng, tali pinggang pemanduan, palam pencucuh, penyejuk, pengelap, dll seperti yang berkenaan.',
      'Semua bahan habis pakai seperti Pembersih Brek, Minyak Gris, Gas Ac, aditif, Fius, dan Penghubung. Sistem ekzos lengkap seperti paip penekan, Muffler, Penukar Katalitik, dan Penapis Partikulat Diesel.',
      'Semua bateri seperti bateri Permulaan, bateri Bantuan, dan bateri Kunci Jauh.',
      'Semua pemasangan lampu termasuk Lampu Hadapan, Lampu Belakang, dan lampu kabus.',
      'Semua bahagian haus dan lusuh seperti roda, Pad Brek dan Cakera, Plat Klac, Bahagian getah yang berkaitan dengan Suspensi seperti, bush, Penyerap kejutan, Penyerap kejutan Boot, Strut Suspensi Udara, Bellows Udara, Rel Sunroof, Panduan Sunroof, pulleys, Bahagian Plastik dan Getah.',
      'Semua pemasangan getah seperti pemasangan Enjin, pemasangan Transmisi, dan pemasangan paip ekzos.',
      'Caj untuk Diagnosis, Pemeriksaan/ujian, Kemas kini Perisian, dan Penyesuaian.',
      'Semua aksesori dan bahagian luar yang dipasang seperti sistem hiburan, dan kit tambah.',
      'Jauh multimedia, jauh kunci pusat, papan pemuka, konsol tengah, sandaran tangan, jam, penutup bumbung, langsir sunroof, karpet lantai, penebat bunyi dan haba.',
      'Semua kerosakan berikutan faktor seperti kebocoran/kemasukan air ke dalam komponen elektrik dan bukan elektrik.',
      'Semua kerosakan yang dilaporkan akibat kelewatan atau kelalaian dalam melaksanakan penyelenggaraan/pembaikan yang dijadualkan di pengedar yang sah.',
      'Semua kerosakan berikutan pemasangan/penggunaan alat ganti, pelincir, atau aksesori bukan asli.',
      'Semua kegagalan berikutan penggunaan bahan api yang tercemar atau salah.',
      'Semua kecacatan sedia ada yang dilihat/catatkan semasa penilaian atau dilaporkan sebelum isu polisi dikeluarkan sehingga ia dibaiki oleh pengedar yang Sah.',
      'Semua tuntutan yang dilaporkan ke atas kenderaan yang telah diisytiharkan sebagai kerugian tunai/kerugian sepenuhnya oleh insurans atau mana-mana pihak berkuasa yang kompeten dan kemudian dibaiki.',
      'Semua kerosakan dan kegagalan berikutan penggunaan berterusan kenderaan walaupun menerima kod kerosakan atau kegagalan untuk mengenal pasti masalah dalam kenderaan.',
      'Pakej Waranti Wisedrive tidak termasuk sebarang bayaran balik untuk pembaikan/penggantian luaran yang dilakukan oleh anda atau untuk sebarang kerosakan akibat kemalangan lain.',
    ],
    subHead4: 'Waranti ini tidak akan terpakai kepada:',
    warrantNotApplyList: [
      'Perkhidmatan penyelenggaraan biasa termasuk tanpa had, pembersihan & penggilapan, pembersihan penyuntik, dekaburisasi enjin, penyelarasan enjin, perubahan minyak/cecair, penambahan penapis, pengetatan pengikat, pelarasan pintu, brek dan klac, imbangan roda, penyelarasan roda, putaran tayar, penyelarasan lampu hadapan.',
      'Penggantian bahagian akibat haus dan lusuh normal, seperti palam pencucuh, tali pinggang, pad brek, kasut brek, cakera brek, cakera klac/plat tekanan, penapis, bilah pengelap, mentol, fius, berus, hos, Tayar/tabung, bateri, sistem audio, audio video navigasi (AVN), penukar katalitik, penekan/paip ekzos.',
      'Tali Rod hujung, Bola Sendi Stereng, Penyerap Kejutan Belakang, Strut Depan, Pengangkat Pintu Belakang, dan Galas Roda Depan & Belakang/hub roda tidak dilindungi melebihi 60,000 Km operasi.',
      "Bahagian getah seperti kit Silinder Roda, semua pelapik/panel cuaca pintu & cincin 'O' A/C, kabel Klac, kabel Pendikit, kabel Speedometer & kabel Pembuka Pintu Belakang.",
      'Kebocoran bahan pendingin A/C.',
      'Penuaan biasa, penurunan kualiti, atau karat pada bahagian yang disalut, lapisan cat, bahagian getah, upholsteri, trim lembut, dll.',
      'Badan, cat, kaca, trim dalaman/luaran, sistem ekzos, dan haus serta lusuh pada mana-mana komponen lain.',
      'Polisi Wisedrive mempunyai tempoh penyejukan lalai selama 10 hari; sebarang tuntutan yang didaftarkan dalam tempoh ini tidak akan dilindungi atau diluluskan.',
      'Jika model Kenderaan dilengkapi dengan Kit LPG/ Kit CNG (sama ada dipasang oleh Pengilang atau dipasang secara tempatan) tidak terpakai untuk Waranti Wisedrive yang Diperluas.',
    ],
    subtitle5: 'Kerosakan atau kegagalan yang disebabkan oleh:',
    DamageFailureList: [
      "Waranti akan terbatal dan tidak akan dipulihkan jika kereta 'tidak' diservis dalam masa yang ditetapkan oleh pelanggan yang mana: Perkhidmatan Umum pertama* dilakukan dalam masa 3 bulan atau sehingga 3,000 Km dari tarikh pengaktifan pakej Waranti (yang mana berlaku terlebih dahulu).",
      'Penyalahgunaan, penyalahgunaan (seperti perlumbaan, overload, menunggang di atas klac), kemalangan atau perlanggaran, kecurian, banjir, atau kebakaran.',
      'Penggunaan bahan api, cecair, atau pelincir yang tidak sesuai, tercemar, atau tidak mencukupi.',
      'Penggunaan bahagian selain daripada Bahagian Asli (OEM).',
      'Mana-mana peranti dan/atau aksesori yang tidak dibekalkan atau tidak diluluskan oleh Wisedrive.',
      'Modifikasi, perubahan, gangguan, atau pembaikan yang tidak betul.',
      'Bahagian yang digunakan dalam aplikasi yang mana ia tidak direka atau tidak diluluskan oleh Wisedrive.',
      'Mana-mana pembaikan yang dilakukan selain oleh Pengedar / Pusat Servis Wisedrive yang Sah.',
      'Ketidakteraturan kecil yang tidak diiktiraf sebagai menjejaskan kualiti atau fungsi kenderaan atau bahagian, seperti bunyi atau getaran kecil, atau item yang dianggap sebagai ciri khas kenderaan.',
      'Jatuhan udara, jatuhan industri, hujan asid, banjir, hail, ribut angin, atau bencana alam yang lain.',
      'Calar pada cat, penyok, atau kerosakan cat atau badan yang serupa.',
      'Revolusi atau Pemberontakan, mana-mana tindakan sengaja atau dipinda oleh pemilik atau pemandu, penyalahgunaan kenderaan, kelalaian.',
      'Tindakan unsur-unsur jalan (pasir, kerikil, debu, atau serpihan jalan) yang menyebabkan kerosakan cat/kaca atau kerosakan pada mana-mana bahagian lain.',
      'Kenderaan yang telah digunakan untuk sebarang jenis pertandingan, sukan, rali, pengangkutan untuk sewaan orang atau barang, perkhidmatan teksi atau sewa sendiri jangka pendek atau panjang atau sekolah memandu, atau penggunaan komersial.',
      'Mana-mana kenderaan yang dibeli sebagai teksi di bawah pengecualian cukai khas atau didaftarkan sebagai teksi Pelancong dengan Pihak Berkuasa Pengangkutan.',
      'Kenderaan yang mana odometernya telah diubah suai, dipindah, atau diputuskan.',
      'Kerosakan atau kegagalan berikutan, termasuk tanpa had, kehilangan masa, kesulitan, kehilangan penggunaan kenderaan, atau kerugian komersial.',
      'Tiada liabiliti akan diterima untuk sebarang kerugian yang dilindungi di bawah polisi kerosakan kemalangan atau risiko jalan raya atau untuk sebarang kerosakan akibat bahaya jalan raya/kebakaran atau kemalangan, tiada liabiliti jenis apa pun wujud berkaitan pihak ketiga.',
      'Tiada liabiliti akan diterima untuk kerosakan yang disebabkan oleh kelalaian, kemasukan bahan asing atau berbahaya, kekurangan penyelenggaraan, kepanasan, pembekuan, atau penyalahgunaan untuk penggunaan kenderaan yang berterusan selepas masalah telah menjadi jelas atau untuk kerugian berikutan kegagalan bahagian yang tidak dilindungi oleh Waranti Diperluas ini.',
    ],
    subHead6: 'TERMA LAIN:',
    otherTermsList: [
      'Pakej Service Inclusive dan/atau Repair Inclusive tersedia untuk semua kereta terpakai* di seluruh julat model (Kecuali Kenderaan Mewah) yang dijual di India.',
      'Pelanggan perlu menempah Service dan/atau Repair Inclusive melalui aplikasi Mudah Alih Wisedrive di bahagian pelan saya atau melalui sokongan pelanggan di +60 122559610.',
      'Semua kerja penyelenggaraan dan servis mesti dijalankan di Bengkel Servis Sah Wisedrive atau oleh Teknikal Wisedrive yang Diluluskan.',
      'Service Inclusive dan/atau Repair Inclusive boleh dipindahkan kepada pemilik seterusnya selepas kelulusan pemeriksaan semula tetapi tidak boleh dipindahkan kepada kereta lain dengan bayaran.',
      'Pelanggan boleh membuat permintaan untuk pembatalan Pakej Service Inclusive dan/atau Repair Inclusive dalam masa dua minggu dari tarikh pengaktifan pakej dengan syarat tiada perkhidmatan telah digunakan pada kereta di bawah sebarang skop. Tiada pembatalan atau pemulangan akan dibuat selepas tempoh yang dinyatakan di atas.',
      'Sekiranya kenderaan yang dilindungi di bawah Service Inclusive dan/atau Repair Inclusive terlibat dalam kemalangan yang menyebabkan ia tidak dapat dibaiki secara ekonomi/kerosakan total, Perkhidmatan Wisedrive Service Maintenance Plan Services Inclusive dan/atau Wisedrive Repair Inclusive akan dibatalkan dan tiada bayaran balik akan dibuat untuk baki tempoh sah. Tiada permintaan pembatalan boleh diproses.',
      'Tiada bayaran balik untuk pekerjaan servis terdahulu.',
      `Wisedrive Technologies (M) Sdn. Bhd. berhak untuk menghentikan, mengubah, menyesuaikan, menambah, atau mengeluarkan mana-mana pakej, skop perkhidmatan, pengecualian, inklusi, dan lain-lain tanpa sebarang pemberitahuan terlebih dahulu. Untuk Terma dan Syarat, polisi dan harga terkini, sila lawati ${(
        <a aria-label="" href="https://www.wisedrive.com">
          https://www.wisedrive.com
        </a>
      )}`,
      'Pembinaan, tafsiran, dan maksud peruntukan Terma dan Syarat ini akan ditentukan mengikut undang-undang India. Mahkamah Bangalore akan mempunyai bidang kuasa eksklusif.',
      'Pemegang waranti mesti mengesahkan dengan Wisedrive Technologies (M) Sdn. Bhd. sebelum meneruskan sebarang jenis pembaikan kenderaan semasa tempoh Waranti. Sekiranya sebarang pembaikan dilakukan tanpa kelulusan dan pengesahan terlebih dahulu, Waranti akan dibatalkan.',
      'Tiada pengedar atau ejen atau pekerja yang diberi kuasa untuk melanjutkan atau membesarkan waranti ini dan tiada pengedar atau ejen atau pekerja yang diberi kuasa untuk membuat waranti lisan bagi pihak Wisedrive. Perkhidmatan waranti hanya akan diberikan oleh pengedar yang diluluskan oleh Wisedrive dan Cawangan Servis Pengedar. Keputusan Wisedrive adalah muktamad dan mengikat pada Pemilik kenderaan dalam semua hal berkaitan waranti. Wisedrive berhak membuat keputusan muktamad mengenai semua hal waranti.',
      'Pengedar, ejen, atau mana-mana kakitangan yang berkaitan tidak mempunyai kuasa atau hak untuk memudahkan atau menjalankan sebarang pembaikan bagi pihak Waranti Wisedrive. Dengan jelas dinyatakan bahawa pengedar, ejen, atau pekerja mereka dilarang mengatur atau membuat komitmen untuk sebarang pembaikan bagi kenderaan yang dilindungi oleh Waranti Wisedrive.',
      'Pengedar, ejen, atau pekerja mereka tidak diberi kuasa untuk membuat tuntutan waranti bagi pihak pelanggan. Sebarang cubaan untuk berbuat demikian akan dianggap sebagai pelanggaran terma dan syarat perjanjian waranti. Pematuhi prosedur yang betul ini memastikan integriti proses waranti dan mengekalkan kewajipan kontrak antara pelanggan dan Waranti Wisedrive. Sebarang penyimpangan dari garis panduan ini boleh mengakibatkan pelanggaran Perjanjian Waranti dan akibatnya.',
    ],
    subHeads7:
      'Kewajipan Pelanggan: Keperluan Sijil Kecergasan untuk Tuntutan Waranti',
    customerObligationFitnessList: [
      'Untuk layak membuat tuntutan waranti, adalah satu prasyarat bagi pelanggan untuk memiliki sijil kecergasan yang sah untuk kenderaan tersebut. Keperluan ini terpakai khususnya kepada kenderaan yang berumur lebih dari 15 tahun atau sebagaimana yang ditetapkan oleh peraturan kerajaan yang berkuat kuasa. Kegagalan untuk menyediakan sijil kecergasan yang sah semasa membuat tuntutan waranti akan menyebabkan tuntutan tersebut ditolak.',
      'Adalah penting untuk difahami bahawa penyampaian sijil kecergasan adalah syarat wajib untuk kelulusan tuntutan waranti. Keperluan ini dibuat untuk memastikan pematuhan dengan piawaian undang-undang dan peraturan.',
      'Kami amat menggalakkan pelanggan untuk memastikan mereka memiliki sijil kecergasan yang sah untuk kenderaan mereka sebelum cuba membuat tuntutan waranti. Kegagalan untuk memenuhi keperluan ini mungkin mengakibatkan penolakan tuntutan, mengikut terma dan syarat yang ditetapkan oleh Wisedrive.',
    ],

    subHead8:
      'Kewajipan Pelanggan: Kemaskini Kad RC Baru untuk Waranti Wisedrive',
    customerObligationRcList: [
      'Pelanggan bertanggungjawab sepenuhnya untuk mengemaskini Kad Sijil Pendaftaran (RC) kenderaan yang baru dengan Wisedrive dalam tempoh 45 hari dari tarikh pengaktifan Waranti Wisedrive. Kegagalan untuk memenuhi kewajipan ini dalam tempoh 45 hari yang ditetapkan akan secara automatik membatalkan Waranti Wisedrive dan ia akan menjadi tidak sah.',
      'Sekiranya waranti dibatalkan, pelanggan boleh memohon pemeriksaan semula kenderaan oleh pasukan Wisedrive untuk mengembalikan pakej waranti. Walau bagaimanapun, ketersediaan slot pemeriksaan adalah bergantung pada budi bicara dan jadual pasukan Wisedrive. Semasa tempoh antara pembatalan waranti dan penyelesaian pemeriksaan semula, waranti akan kekal tidak boleh dituntut dan tidak sah. Kelanjutan waranti kenderaan adalah bergantung pada budi bicara pasukan Wisedrive, dan penemuan mereka semasa proses pemeriksaan.',
      'Penting untuk diingat bahawa Wisedrive berhak menolak kelulusan semula waranti berdasarkan hasil pemeriksaan.',
      'Kami menekankan kepentingan mematuhi kewajipan ini untuk memastikan kesahihan dan perlindungan yang berterusan bagi Waranti Wisedrive anda.',
      'Untuk membuat tuntutan waranti, adalah penting bahawa nama pemilik kereta dan butiran yang terkandung dalam Sijil Pendaftaran Kenderaan (buku RC) sepadan dengan maklumat yang dinyatakan dalam Polisi waranti. Sebarang perbezaan atau ketidaksesuaian antara butiran pemilik dan dokumentasi waranti boleh menyebabkan tuntutan waranti ditolak.',
      'Adalah menjadi tanggungjawab pemilik kereta untuk memastikan bahawa maklumat yang terkandung dalam buku RC, termasuk nama, alamat, dan butiran lain yang berkaitan, sepadan dengan maklumat yang diberikan dalam polisi waranti. Sebarang perubahan atau kemas kini maklumat perlu segera dimaklumkan kepada pihak berkuasa Wisedrive dan dipaparkan dengan betul dalam buku RC dan dokumentasi waranti.',
      'Wisedrive berhak menolak tuntutan waranti sekiranya terdapat kegagalan untuk mematuhi keperluan ini. Dinasihatkan agar pemilik kereta menyemak dan mengesahkan ketepatan maklumat mereka dalam kedua-dua buku RC dan polisi waranti untuk mengelakkan sebarang komplikasi atau penolakan tuntutan waranti.',
    ],
    subHead9: 'Tanggungjawab Pemilik:',
    responsibilitiesList: [
      'Penggunaan, penyelenggaraan, dan penjagaan kenderaan yang betul mengikut arahan yang terkandung dalam Manual Pemilik dan Buku Servis. Sekiranya kenderaan digunakan dalam keadaan penggunaan yang teruk, seperti operasi dalam keadaan berdebu, kasar, pemanduan jarak dekat yang lebih kerap atau kesesakan lalu lintas yang berat pada cuaca panas, penyelenggaraan kenderaan perlu dilakukan dengan lebih kerap seperti yang dinyatakan dalam Manual Pemilik dan Buku Servis.',
      'Untuk mengekalkan kesahihan Waranti Lanjutan ini, kenderaan mesti diselenggara oleh Pusat Servis/Pengedar Wisedrive yang Sah mengikut Manual Pemilik dan Buku Servis.',
      'Penahanan rekod perkhidmatan penyelenggaraan. Pelanggan mungkin perlu menunjukkan bahawa penyelenggaraan yang diperlukan telah dilakukan, seperti yang dinyatakan dalam Manual Pemilik dan Buku Servis.',
      'Penghantaran kenderaan bersama Manual Pemilik dan Buku Servis serta Sijil Waranti Lanjutan semasa waktu perniagaan servis biasa ke mana-mana Pengedar Wisedrive yang Sah untuk mendapatkan perkhidmatan waranti.',
    ],
    subHead10:
      'Kesalahan Pemandu/Manual Tidak Dilindungi Di Bawah Tuntutan Waranti',
    subTitle1: 'Kegagalan untuk mengekalkan tahap minyak yang betul:',
    subTitleList: [
      'Mengabaikan untuk memeriksa dan mengekalkan minyak enjin pada tahap yang disyorkan secara berkala.',
      'Pelinciran yang tidak mencukupi menyebabkan geseran dan haus yang meningkat pada komponen enjin.',
      'Akibat yang berpotensi: Kerosakan enjin, kerosakan pada bahagian dalaman.',
    ],
    subTitle2: 'Mengabaikan selang masa penukaran minyak:',
    subTitle2List: [
      'Mengabaikan penukaran minyak yang tepat pada masanya menyebabkan minyak menjadi rosak dan pelinciran yang berkurangan.',
      'Minyak yang tercemar menyebabkan peningkatan haus enjin dan potensi kegagalan.',
      'Akibat yang berpotensi: Kerosakan enjin, dan prestasi enjin yang menurun.',
    ],
    subTitle3: 'Melebihi suhu enjin:',
    subTitle3List: [
      'Membiarkan enjin terlalu panas akibat kerosakan sistem penyejukan atau paras cecair penyejuk yang rendah.',
      'Tekanan berlebihan pada enjin menyebabkan kerosakan yang teruk.',
      'Akibat yang berpotensi: Kepala silinder yang berubah bentuk, gasket kepala yang rosak, enjin yang tersekat.',
    ],
    subTitle4: 'Menggunakan bahan api atau minyak yang tidak betul:',
    subTitle4List: [
      'Menggunakan jenis bahan api yang salah (contohnya, petrol bukannya diesel) atau minyak enjin yang tidak sesuai.',
      'Gangguan pada proses pembakaran enjin dan prestasi yang lemah.',
      'Akibat yang berpotensi: Kerosakan enjin, dan penurunan kecekapan bahan api.',
    ],
    subTitle5: 'Mengabaikan tanda amaran:',
    subTitle5List: [
      'Mengabaikan tanda amaran enjin seperti bunyi yang tidak biasa, asap yang berlebihan, kehilangan kuasa, atau lampu amaran pada papan pemuka.',
      'Kegagalan untuk menangani petunjuk awal masalah enjin.',
      'Akibat yang berpotensi: Kerosakan lebih lanjut, kegagalan enjin, keselamatan yang terjejas.',
    ],
    subTitle6: 'Memutar enjin terlalu tinggi atau mencapai had maksimum:',
    subTitle6List: [
      'Memutar enjin secara berlebihan atau mengoperasikannya secara berterusan pada RPM tinggi.',
      'Memberikan tekanan berlebihan pada komponen enjin dan mempercepatkan haus.',
      'Akibat yang berpotensi: Peningkatan haus pada enjin, dan pengurangan jangka hayat enjin. Pemeliharaan yang tidak betul dan pengabaian:',
      'Gagal melaksanakan tugas penyelenggaraan rutin (contohnya, penukaran tali sawat masa, penukaran palam pencucuh, penukaran penapis udara).',
      'Kemusnahan komponen enjin akibat pengabaian.',
      'Akibat yang berpotensi: Masalah enjin, penurunan prestasi, peningkatan risiko kegagalan.',
    ],

    subNote:
      'Perlu diingat bahawa senarai ini tidak lengkap, dan model kenderaan tertentu mungkin mempunyai garis panduan dan keperluan tambahan yang diterangkan dalam manual pemilik masing-masing. Sentiasa rujuk kepada cadangan pengeluar dan ikuti prosedur penyelenggaraan yang betul untuk memastikan kelestarian dan prestasi kenderaan anda.',
    noteHeader: 'Nota Penting:',
    noteList: [
      'Jaminan Lanjutan ini boleh dipindahkan kepada pemilik seterusnya untuk Tempoh Jaminan yang tinggal selepas kelulusan pemeriksaan semula.',
      'Wisedrive berhak untuk membatalkan/menolak permohonan pemindahan jaminan berdasarkan pemeriksaan semula.',
      'Skim Jaminan Lanjutan ini tiada nilai penyerahan, tiada pemulangan premium jaminan yang tersedia dan tidak boleh dipindahkan kepada kenderaan lain.',
      'Jaminan Lanjutan tidak terpakai pada kenderaan Teksi/Fleet dan Kenderaan Ujian Pandu.',
      'Semua perkhidmatan Penyelenggaraan dan pembaikan tuntutan jaminan akan dijalankan secara eksklusif di peringkat daerah dalam negeri Karnataka di Pusat Servis/Tapak Servis/Workshop yang diluluskan/diiktiraf oleh Wisedrive.',
      'Insurans kenderaan yang sah perlu dikemukakan oleh pemegang jaminan semasa menghantar/ Meminta tuntutan jaminan. Kegagalan untuk menyediakan bukti insurans akan menyebabkan tuntutan jaminan ditolak.',
      'Permohonan Tuntutan Jaminan untuk liputan jaminan di luar negeri Karnataka tidak akan dipertimbangkan sebagai feasible atau layak.',
      'Semua perkhidmatan Penyelenggaraan untuk permintaan servis di luar negeri Karnataka tidak akan dipertimbangkan sebagai feasible atau layak.',
      'Harga Jaminan Lanjutan boleh berubah tanpa sebarang pemberitahuan terlebih dahulu.',
      'Semua pilihan Jaminan Lanjutan di atas boleh berubah/pupus tanpa sebarang pemberitahuan terlebih dahulu.',
      'Pemegang Jaminan perlu mengemukakan permohonan tuntutan/pertanyaan melalui saluran helpline (Emel - Claims.my@wisedrive.com, Nombor Telefon - +60 122559610) dalam tempoh 48 jam dari kejadian tuntutan, jika gagal, tuntutan tersebut akan dianggap tidak sah.',
      'Semua pertikaian yang timbul daripada Jaminan Lanjutan ini akan tertakluk kepada bidang kuasa Mahkamah di Bangalore sahaja.',
      `Wisedrive berhak untuk membuat penambahbaikan atau mengubah ciri-ciri atau reka bentuk semua pelan perlindungan Wisedrive pada bila-bila masa tanpa kewajipan kepada kenderaan yang telah dijamin. Untuk Terma dan Syarat terkini, polisi dan harga, sila layari ${(
        <a aria-label="" href="https://www.wisedrive.com">
          https://www.wisedrive.com
        </a>
      )} atau hubungi sokongan pelanggan Wisedrive di +60 122559610 melalui telefon atau emel kami di support.my@wisedrive.com.`,
    ],
  },
  termsPage: {
    header: 'Terma & Syarat',
    contentArray: [
      {
        data: (
          <>
            <strong>Kami/Kita dan Kami </strong>
            bermaksud Wisedrive Technologies (M) Sdn. Bhd.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Perjanjian </strong>bermaksud perjanjian antara Wisedrive
            dan Pelanggan di mana Wisedrive bersetuju untuk mengatur agar
            seorang Pemeriksa menjalankan Pemeriksaan selaras dengan terma dan
            syarat ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Yuran Pembatalan </strong>bermaksud jumlah yang perlu
            dibayar oleh Pelanggan seperti yang dinyatakan dalam terma dan
            syarat ini.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pelanggan/Anda </strong>bermaksud pelanggan Wisedrive yang
            membuat tempahan untuk Pemeriksaan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Yuran </strong>bermaksud jumlah yang perlu dibayar oleh
            Pelanggan kepada Wisedrive untuk Pemeriksaan seperti yang dinyatakan
            di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pemeriksaan </strong>bermaksud pemeriksaan visual audio dan
            luaran serta pandu uji yang dilakukan oleh seorang Pemeriksa bagi
            pihak Wisedrive untuk Pelanggan selaras dengan terma dan syarat ini.
          </>
        ),
      },
      {
        data: (
          <>
            Wisedrive menyediakan beberapa kategori Pemeriksaan yang berbeza,
            setiap satu melibatkan semakan yang berbeza. Butiran mengenai
            kategori pemeriksaan yang berlainan dan semakan yang terlibat boleh
            didapati di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
            &nbsp; atau dengan menghubungi +60 122559610. Pengesahan kategori
            Pemeriksaan yang dipilih oleh Pelanggan akan dilakukan pada
            Kenderaan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Pemeriksa </strong>merujuk kepada pemeriksa bertauliah yang
            menjalankan Pemeriksaan bagi pihak Wisedrive. Pemeriksa adalah
            tertakluk kepada ketersediaan dan boleh digantikan dengan ejen pihak
            ketiga yang bersesuaian.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Laporan </strong>bermaksud laporan bertulis yang dihasilkan
            oleh Pemeriksa sebagai sebahagian daripada Pemeriksaan, yang
            merangkumi nama dan alamat Pelanggan, butiran pendaftaran Kenderaan
            yang diperiksa serta lokasinya, sama ada Kenderaan tersebut lulus
            atau gagal dalam Pemeriksaan, senarai semakan yang dilakukan
            (bergantung kepada jenis Pemeriksaan yang diminta oleh Pelanggan)
            dan ringkasan mana-mana aspek kebimbangan yang perlu diberi
            perhatian oleh Pelanggan.
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Senarai Semakan Laporan </strong>bermaksud senarai aspek
            yang akan atau telah diperiksa oleh Pemeriksa sebagai sebahagian
            daripada Pemeriksaan Fizikal, yang boleh didapati di{' '}
            <a aria-label="" href="https://www.wisedrive.com">
              https://www.wisedrive.com
            </a>
          </>
        ),
      },
      {
        data: (
          <>
            <strong>Kenderaan </strong>bermaksud kenderaan yang mana Pelanggan
            memerlukan Pemeriksa untuk menjalankan Pemeriksaan.
          </>
        ),
      },
    ],
    subHeader: 'Umum',
    listContent: [
      'Pemeriksaan disediakan berdasarkan pemeriksaan visual dan luaran sahaja dan terhad kepada bahagian dan/atau item yang dikenal pasti dalam Laporan. Pemeriksaan tidak melibatkan pembongkaran atau gangguan terhadap mana-mana struktur, komponen atau mekanisme dalaman. Pemeriksa akan menjalankan ujian jalan ke atas Kenderaan dan menghasilkan Laporan. Terdapat bahagian tertentu dalam Kenderaan yang tidak akan diperiksa. Anda harus membaca Senarai Semakan Laporan dengan teliti untuk melihat apa yang tidak akan diperiksa.',
      'Salinan Laporan akan dihantar kepada Anda melalui e-mel ke alamat e-mel yang Anda berikan semasa membuat tempahan Pemeriksaan. Disebabkan sifat internet dan perisian perlindungan virus yang digunakan oleh penyedia perkhidmatan internet Anda atau dipasang pada komputer Anda, mungkin tidak dapat dijamin bahawa Laporan akan dihantar melalui e-mel dalam semua kes. Jika Anda tidak menerima Laporan Anda dalam tempoh 24 jam selepas Pemeriksaan Kenderaan Wisedrive, Anda mesti memaklumkan kepada Kami secepat mungkin supaya Kami dapat menghantar semula Laporan kepada Anda.',
      'Item yang disenaraikan dalam Senarai Semakan Laporan sebagai bahagian/item yang perlu diperiksa, tetapi tidak dapat diakses dengan mudah pada Kenderaan, tidak akan diperiksa. Dalam keadaan sedemikian, Kami tidak mempunyai kewajipan untuk memeriksa dan/atau melaporkan bahagian/item tersebut dan Pemeriksa akan menandakan bahagian yang berkaitan dalam Laporan dengan sewajarnya.',
      'Kenderaan harus dalam keadaan bersih bagi memastikan Pemeriksa dapat melihat dan melaporkan secara tepat mengenai bahagian kenderaan yang diperiksa. Jika kenderaan tidak bersih, Pemeriksa berhak untuk tidak memberi komen mengenai bahagian tersebut dan akan menandakan Senarai Semakan Laporan dengan sewajarnya. Dalam kes ini, Yuran Laporan tetap perlu dibayar sepenuhnya.',
    ],
    subHeader3: (
      <>
        <strong>Ujian Jalan Raya </strong>
      </>
    ),
    listContent2: [
      <>
        Untuk membolehkan Pemeriksa kami menjalankan Ujian Jalan Raya ke atas
        Kenderaan, Anda mesti memastikan bahawa kenderaan mengandungi jumlah
        yang mencukupi:
        <br /> (a) Air; <br /> (b) Minyak;
        <br /> (c) Petrol.
      </>,
      'Ujian jalan raya dijalankan dalam kawasan sekitar Pemeriksaan. Jika:',
      'Kenderaan berada dalam keadaan tidak selamat untuk dipandu atau mengandungi jumlah minyak, air dan/atau petrol yang tidak mencukupi',
      'Pelanggan tidak dapat mengesahkan bahawa Kenderaan mempunyai sijil kecergasan yang sah dan oleh itu ujian jalan raya tidak dapat dijalankan semasa Pemeriksaan',
      'Bayaran bagi Pemeriksaan masih perlu dibayar sepenuhnya dan bayaran tambahan akan dikenakan untuk sebarang ujian jalan raya susulan yang Anda minta Kami jalankan.',
      'Pelaksanaan ujian jalan raya tidak bermaksud Pemeriksa kami telah melihat sijil kecergasan yang sah.',
      'Mendapatkan kebenaran yang diperlukan serta akses ke Kenderaan adalah tanggungjawab Pelanggan.',
      'Pelanggan mesti memastikan bahawa penyediaan yang betul telah dibuat (termasuk mendapatkan sebarang kebenaran yang diperlukan daripada pemilik Kenderaan) untuk Pemeriksaan dijalankan di premis bengkel atau di kawasan luar jalan dengan permukaan rata, keras dan kering.',
      'Pemeriksa kami memerlukan ruang yang mencukupi untuk berjalan mengelilingi Kenderaan dan membuka semua pintu sepenuhnya. Pemeriksa kami juga perlu mempunyai ruang yang mencukupi untuk meletakkan kenderaannya berhampiran lokasi Pemeriksaan.',
      'Pencahayaan dalaman berkualiti tinggi atau cahaya matahari yang mencukupi (jika Pemeriksaan dilakukan di luar) mesti disediakan di lokasi Pemeriksaan. Kami tidak dapat memeriksa Kenderaan dalam pencahayaan yang lemah atau dalam keadaan gelap.',
    ],
    subHeader4: 'Bayaran dan Pembatalan',
    listContent3: [
      'Bayaran mesti dibuat semasa tempahan Pemeriksaan.',
      <>
        Kami berhak untuk menolak menjalankan Pemeriksaan atau mengeluarkan
        Laporan untuk sebarang kenderaan: yang tidak boleh diakses oleh
        Pemeriksa dengan wajar; atau yang kelihatan kepada Pemeriksa sebagai:
        <br /> (a) bukan keluaran standard (contohnya, tetapi tidak terhad
        kepada, kereta kit);
        <br /> (b) telah diubah suai atau tidak digunakan secara kerap
        (contohnya, menunjukkan tanda-tanda kakisan berlebihan pada bahagian
        bergerak akibat dibiarkan terlalu lama dan boleh menyebabkan Kenderaan
        tidak selamat untuk dipandu tanpa pembaikan);
        <br /> (c) tidak selamat untuk dipandu atau berada dalam keadaan tidak
        layak di jalan raya.
      </>,
      'Mana-mana keadaan yang dirujuk dalam Terma & Syarat ini.',
      'Di mana Pelanggan gagal memastikan penyediaan yang betul untuk Pemeriksaan dijalankan, seperti yang diperlukan.',
      'Di mana Pelanggan telah memberikan maklumat yang salah atau tidak lengkap yang menghalang Kami daripada menjalankan Pemeriksaan dan Anda mengakui bahawa dalam keadaan sedemikian Kami berhak untuk menganggap Perjanjian sebagai ditamatkan dan menyimpan Bayaran sepenuhnya.',
      'Jika Anda ingin Kami menjalankan Pemeriksaan lain, Anda perlu membuat bayaran tambahan semasa tempahan baru.',
      'Anda berhak untuk membatalkan Pemeriksaan dan menerima pemulangan penuh Bayaran jika pembatalan dibuat sekurang-kurangnya 24 jam sebelum Pemeriksaan dijadualkan. Setelah Pemeriksaan dijalankan, tiada pemulangan bayaran akan diberikan.',
      'Untuk membatalkan Pemeriksaan, Anda mesti memaklumkan Pasukan Sokongan Pelanggan kami tentang keputusan Anda dengan menghantar e-mel ke support.my@wisedrive.com atau menghubungi +60 122559610, Isnin hingga Jumaat dari jam 9 pagi hingga 5 petang.',
      'Bagi membolehkan kami mencari tempahan Anda, Anda perlu memberikan nama, alamat, nombor telefon dan nombor rujukan tempahan (seperti yang diberikan dalam pengesahan tempahan Anda) bersama permohonan pembatalan Anda.',
    ],
    subHeader5: 'Aduan',
    listContent4: [
      'Jika Anda mempunyai aduan atau tidak berpuas hati dengan sebarang Pemeriksaan yang telah dijalankan, sila hubungi Kami di +60 122559610 secepat mungkin. Kami mungkin perlu menjalankan pemeriksaan semula ke atas Kenderaan untuk menangani aduan tersebut, dan Anda bersetuju untuk membenarkan Kami berbuat demikian.',
      'Tiada pembaikan boleh dilakukan atau mana-mana bahagian kenderaan diganti sebelum Pemeriksaan semula dijalankan oleh Kami. Jika pembaikan kecemasan diperlukan bagi memastikan Kenderaan selamat digunakan dan kemudian menjadi subjek aduan kepada Kami, Anda mesti memastikan aduan dibuat kepada Kami (termasuk pemberitahuan mengenai keperluan pembaikan kecemasan) dalam tempoh yang munasabah selepas masalah ditemui. Mana-mana bahagian yang rosak atau haus yang telah dibaiki atau diganti mesti disimpan untuk pemeriksaan lanjut oleh Kami. Kami tidak akan bertanggungjawab dalam apa jua keadaan terhadap kos pembaikan atau penggantian bahagian tanpa persetujuan bertulis terdahulu daripada Kami.',
      'Kami berhak untuk memerlukan seorang lagi Pemeriksa Kami untuk menjalankan Pemeriksaan semula ke atas mana-mana Kenderaan atas perbelanjaan Kami sendiri jika dianggap perlu untuk menangani sebarang aduan. Anda juga dikehendaki membenarkan Pemeriksa Kami menjalankan Pemeriksaan semula tersebut mengikut terma dan syarat ini. Kami akan memberikan pendapat kedua yang tidak berat sebelah terhadap Laporan awal yang dikeluarkan.',
    ],
    subHeader6: 'Perkara di luar kawalan munasabah Kami',
    listContent5: [
      'Kami tidak akan bertanggungjawab terhadap sebarang kelewatan atau ketidakupayaan untuk menjalankan Pemeriksaan akibat kejadian atau keadaan di luar kawalan munasabah Kami. Kami akan mengambil langkah untuk mengurangkan kesannya sekiranya boleh.',
      'Wisedrive hanya akan bertanggungjawab kepada Pelanggan (dan bukan kepada mana-mana pihak lain) sekiranya Wisedrive gagal menjalankan Pemeriksaan mengikut terma dan syarat ini. Tanpa mengehadkan perkara di atas, Anda mengakui bahawa Wisedrive atau Pemeriksa tidak akan bertanggungjawab kepada Anda atau mana-mana pihak lain atas sebarang liabiliti, kerugian, kerosakan, tuntutan, prosiding, kos atau perbelanjaan (secara kolektif dirujuk sebagai "Kerugian") yang dialami atau ditanggung dalam mana-mana keadaan berikut:',
      'Kerugian tersebut bukan akibat yang boleh diramalkan secara munasabah daripada sebarang pelanggaran (Kerugian dianggap boleh diramalkan jika ia boleh dijangkakan oleh Anda dan Kami pada masa Pemeriksaan Kenderaan dilakukan).',
      'Kerugian tersebut tidak disebabkan secara langsung oleh pelanggaran terma dan syarat ini oleh Kami atau Pemeriksa.',
      'Kerugian tersebut melibatkan kerugian perniagaan atau lain-lain kerugian kepada pelanggan yang bukan pengguna.',
      'Kerugian tersebut meningkat akibat daripada pelanggaran mana-mana terma dan syarat ini oleh Anda.',
      'Tiada apa-apa dalam dokumen ini yang akan menjejaskan hak statutori pengguna di bawah mana-mana undang-undang yang berkenaan.',
    ],
    subHeader7: 'Penguatkuasaan terma',
    listContent6: [
      'Setiap klausa dalam terma ini beroperasi secara berasingan. Jika mana-mana mahkamah atau pihak berkuasa yang berkaitan memutuskan bahawa mana-mana daripadanya adalah tidak sah, klausa yang selebihnya akan tetap berkuat kuasa sepenuhnya.',
      'Perjanjian ini adalah antara Anda dan Wisedrive. Tiada pihak lain yang mempunyai hak untuk menguatkuasakan mana-mana terma dalam Perjanjian ini. Kita juga tidak perlu mendapatkan persetujuan mana-mana pihak untuk membuat sebarang perubahan kepada terma ini.',
    ],
    subHeader8: 'Nasihat berkaitan Laporan',
    listContent7: [
      'Anda dinasihatkan agar membincangkan penemuan dalam Laporan dengan penjual sebelum membuat keputusan untuk membeli Kenderaan. Jika Anda belum melihat Kenderaan secara peribadi, Anda mesti memastikan bahawa keadaan kosmetik dan spesifikasi Kenderaan adalah memuaskan dan sesuai dengan keperluan serta jangkaan Anda. Kami mencadangkan agar Anda melihat dan memandu sendiri Kenderaan sebelum membuat keputusan pembelian.',
    ],
  },
  aiComponent: {
    header:
      'Meningkatkan Kepercayaan dan Ketelusan dalam Pemeriksaan Kereta Terpakai dengan AI/ML',
    description:
      'Wisedrive menggunakan algoritma canggih untuk mengesan, mengklasifikasikan, dan mentafsir corak bunyi enjin. Teknologi ini membantu mengenal pasti masalah seperti misfire, getaran tidak teratur, atau kehausan, membolehkan penyelenggaraan proaktif. Ini memastikan prestasi enjin yang lebih baik, kebolehpercayaan, dan kecekapan operasi.',
    cardData: [
      {
        header: '20x',
        subtitle: 'Analisis Enjin yang Lebih Tepat',
        description:
          'AI kami yang dilatih dengan lebih daripada sejuta bunyi enjin mempunyai analisis enjin yang lebih tepat dan dapat mengesan masalah berkaitan.',
      },
      {
        header: '95%',
        subtitle: 'Mengurangkan Kesilapan Manusia',
        description:
          'Pemeriksaan kami mengurangkan campur tangan manusia dan meningkatkan kualiti laporan menggunakan AI dan ML.',
      },
      {
        header: '75%',
        subtitle: 'Masa Pemeriksaan Lebih Singkat',
        description:
          'Teknologi kami memastikan pengurangan masa pemeriksaan sebanyak 75% dan laporan pemeriksaan dapat disiapkan dalam masa kurang daripada 30 minit.',
      },
      {
        header: '99.99%',
        subtitle: 'Jaminan Kualiti Pemeriksaan',
        description:
          'AI kami menyediakan ketepatan kualiti pemeriksaan sebanyak 99.99% dengan analitik bunyi termaju dan analisis enjin menggunakan pengimbas OBD2.',
      },
    ],
  },
  cancellationAndRefund: {
    header: 'POLISI PEMBATALAN DAN PEMULANGAN WANG',
    dataArray: [
      {
        subHeader: '1. DALAM TEMPOH 10 HARI PERTAMA',
        description:
          'Setiap pemegang polisi jaminan / pengedar yang telah membeli polisi jaminan lanjutan daripada Wisedrive Technologies (M) Sdn. Bhd. boleh memohon pembatalan polisi dan pemulangan wang penuh dalam tempoh 10 (sepuluh) hari kalendar dari tarikh penerimaan bayaran premium polisi jaminan. Pemegang Polisi / Pengedar mesti mengemukakan permohonan pembatalan dan pemulangan wang secara bertulis melalui e-mel kepada Wisedrive Technologies (M) Sdn. Bhd. di support.my@wisedrive.com ("Permohonan Pembatalan"). Setelah menerima Permohonan Pembatalan dalam tempoh yang ditetapkan, polisi jaminan akan dibatalkan oleh Wisedrive Technologies (M) Sdn. Bhd. dan jumlah penuh yang telah dibayar oleh Pemegang Polisi / Pengedar akan dikembalikan. Adalah dimaklumkan bahawa, jaminan dan semua hak di bawah Polisi Jaminan akan terbatal serta-merta dari tarikh Permohonan Pembatalan. Tiada tuntutan akan dipertimbangkan oleh Wisedrive Technologies (M) Sdn. Bhd. daripada Pemegang Polisi / Pengedar selepas tarikh Permohonan Pembatalan.',
      },
      {
        subHeader: '2. PERMOHONAN PEMBATALAN DITERIMA SELEPAS 10 HARI PERTAMA',
        description:
          'Pemegang Polisi Jaminan hanya berhak menerima pemulangan wang sekiranya pembatalan polisi dibuat dalam tempoh 10 hari dari tarikh penerimaan premium. Pemegang Polisi Jaminan masih boleh mengemukakan permohonan pembatalan selepas tempoh yang ditetapkan, namun bagi sebarang Permohonan Pembatalan yang diterima selepas tempoh tersebut, tiada pemulangan wang akan diproses oleh Wisedrive Technologies (M) Sdn. Bhd..',
      },
      {
        subHeader: '3. KAEDAH PEMBAYARAN DAN PEMULANGAN WANG',
        description:
          'Bagi Permohonan Pembatalan yang dibuat dalam tempoh 10 hari selepas pembayaran, pemulangan wang akan diproses dalam tempoh 14 (empat belas) hari bekerja dari tarikh penerimaan Permohonan Pembatalan. Pemulangan wang akan dibuat melalui kaedah pembayaran asal, iaitu kaedah yang digunakan oleh Pemegang Polisi Jaminan semasa pembayaran awal. Walau bagaimanapun, Wisedrive Technologies (M) Sdn. Bhd. boleh, mengikut budi bicara mereka, memproses pemulangan wang melalui kaedah lain setelah menerima arahan khusus daripada Pemegang Polisi Jaminan berserta maklumat yang diperlukan dalam Permohonan Pembatalan.',
      },
    ],
  },
  privacyData: {
    header: 'Dasar Privasi Wisedrive Technologies (M) Sdn. Bhd.',
    contentArray: [
      {
        subHeader: 'Apa yang kami lakukan dengan maklumat anda?',
        subContent:
          'Apabila anda membeli sesuatu dari kedai kami, sebagai sebahagian daripada proses pembelian dan penjualan, kami mengumpul maklumat peribadi yang anda berikan kepada kami seperti nama, alamat dan alamat e-mel anda. Apabila anda melayari kedai kami, kami juga secara automatik menerima alamat protokol internet (IP) komputer anda untuk memberikan kami maklumat yang membantu kami memahami pelayar dan sistem operasi anda. Pemasaran e-mel (jika berkenaan): Dengan kebenaran anda, kami boleh menghantar e-mel mengenai kedai kami, produk baru dan kemas kini lain.',
      },
      {
        subHeader: 'Persetujuan',
        subContent:
          'Bagaimana anda memberikan persetujuan anda? Apabila anda memberikan maklumat peribadi kepada kami untuk menyelesaikan transaksi, mengesahkan kad kredit anda, membuat pesanan, mengatur penghantaran atau memulangkan pembelian, kami menganggap bahawa anda bersetuju untuk kami mengumpul dan menggunakannya hanya untuk tujuan tertentu tersebut. Jika kami meminta maklumat peribadi anda untuk tujuan sekunder, seperti pemasaran, kami akan meminta kebenaran anda secara langsung atau memberikan anda peluang untuk menolaknya. Bagaimana saya boleh menarik balik persetujuan saya? Jika selepas anda bersetuju, anda menukar fikiran, anda boleh menarik balik persetujuan anda untuk kami menghubungi anda, untuk terus mengumpul, menggunakan atau mendedahkan maklumat anda pada bila-bila masa dengan menghubungi kami di support.my@wisedrive.com.',
      },
      {
        subHeader: 'Pendedahan',
        subContent:
          'Kami mungkin mendedahkan maklumat peribadi anda jika kami dikehendaki berbuat demikian oleh undang-undang atau jika anda melanggar Terma Perkhidmatan kami.',
      },
      {
        subHeader: 'Pembayaran',
        subContent:
          'Kami menggunakan Razorpay untuk memproses pembayaran. Kami/Razorpay tidak menyimpan data kad anda di pelayan mereka. Data tersebut disulitkan melalui Standard Keselamatan Data Kad Pembayaran (PCI-DSS) semasa pemprosesan pembayaran. Data transaksi pembelian anda hanya digunakan selagi diperlukan untuk menyelesaikan transaksi pembelian anda. Selepas itu, maklumat transaksi pembelian anda tidak disimpan. Gerbang pembayaran kami mematuhi piawaian yang ditetapkan oleh PCI-DSS yang dikendalikan oleh Majlis Piawaian Keselamatan PCI, yang merupakan usaha bersama jenama seperti Visa, MasterCard, American Express dan Discover. Keperluan PCI-DSS membantu memastikan pengendalian maklumat kad kredit yang selamat oleh kedai kami dan penyedia perkhidmatannya. Untuk maklumat lanjut, anda juga boleh membaca terma dan syarat Razorpay.',
      },
      {
        subHeader: 'Perkhidmatan pihak ketiga',
        subContent:
          'Secara amnya, penyedia pihak ketiga yang digunakan oleh kami hanya akan mengumpul, menggunakan dan mendedahkan maklumat anda sejauh mana yang diperlukan untuk membolehkan mereka menjalankan perkhidmatan yang mereka sediakan kepada kami. Walau bagaimanapun, penyedia perkhidmatan pihak ketiga tertentu, seperti gerbang pembayaran dan pemproses transaksi pembayaran lain, mempunyai dasar privasi mereka sendiri berhubung dengan maklumat yang kami perlu berikan kepada mereka untuk transaksi pembelian anda. Untuk penyedia ini, kami mengesyorkan anda membaca dasar privasi mereka supaya anda memahami bagaimana maklumat peribadi anda akan dikendalikan oleh penyedia ini. Secara khususnya, perlu diingat bahawa penyedia tertentu mungkin berada atau mempunyai kemudahan yang terletak di bidang kuasa yang berbeza daripada anda atau kami. Jadi, jika anda memilih untuk meneruskan transaksi yang melibatkan perkhidmatan penyedia pihak ketiga, maka maklumat anda mungkin tertakluk kepada undang-undang bidang kuasa di mana penyedia perkhidmatan itu atau kemudahannya terletak. Sebaik sahaja anda meninggalkan laman web kedai kami atau dialihkan ke laman web atau aplikasi pihak ketiga, anda tidak lagi tertakluk kepada Dasar Privasi ini atau Terma Perkhidmatan laman web kami. Pautan Apabila anda mengklik pautan di kedai kami, pautan tersebut boleh mengarahkan anda ke luar dari laman web kami. Kami tidak bertanggungjawab terhadap amalan privasi laman web lain dan menggalakkan anda membaca kenyataan privasi mereka.',
      },
      {
        subHeader: 'Keselamatan',
        subContent:
          'Untuk melindungi maklumat peribadi anda, kami mengambil langkah berjaga-jaga yang munasabah dan mengikuti amalan terbaik industri untuk memastikan maklumat tersebut tidak hilang, disalahgunakan, diakses, didedahkan, diubah atau dimusnahkan dengan tidak sepatutnya.',
      },
      {
        subHeader: 'Cookies',
        subContent:
          'Kami menggunakan cookies untuk mengekalkan sesi pengguna anda. Ia tidak digunakan untuk mengenal pasti anda secara peribadi di laman web lain.',
      },
      {
        subHeader: 'Umur persetujuan',
        subContent:
          'Dengan menggunakan laman ini, anda mengesahkan bahawa anda sekurang-kurangnya telah mencapai umur dewasa di negeri atau wilayah tempat tinggal anda, atau bahawa anda telah mencapai umur dewasa di negeri atau wilayah tempat tinggal anda dan anda telah memberikan kebenaran kepada kami untuk membenarkan tanggungan bawah umur anda menggunakan laman ini.',
      },
      {
        subHeader: 'Perubahan kepada dasar privasi ini',
        subContent:
          'Kami berhak untuk mengubah dasar privasi ini pada bila-bila masa, jadi sila semak ia dengan kerap. Perubahan dan penjelasan akan berkuat kuasa serta-merta selepas dipaparkan di laman web. Jika kami membuat perubahan ketara kepada dasar ini, kami akan memberitahu anda di sini bahawa ia telah dikemas kini, supaya anda menyedari maklumat apa yang kami kumpulkan, bagaimana kami menggunakannya, dan dalam keadaan apa, jika ada, kami menggunakannya dan/atau mendedahkannya. Jika kedai kami diperoleh atau bergabung dengan syarikat lain, maklumat anda mungkin akan dipindahkan kepada pemilik baru supaya kami boleh terus menjual produk kepada anda.',
      },
      {
        subHeader: 'Soalan & maklumat hubungan',
        subContent:
          'Jika anda ingin: mengakses, membetulkan, mengubah atau memadam sebarang maklumat peribadi yang kami ada tentang anda, membuat aduan, atau sekadar mahukan maklumat lanjut, sila hubungi Pegawai Pematuhan Privasi kami di support.my@wisedrive.com.',
      },
    ],
  },
  reportData: {
    reportFor: 'Laporan untuk',
    inspectedBy: 'Diperiksa oleh',
    marketValue: 'Nilai Pasaran',
    overallRating: 'Penilaian Keseluruhan',
    recommendedToBuy: 'Disyorkan untuk membeli',
    inspectionDetailsTitle: 'Butiran Pemeriksaan',
    mechanicName: 'Nama Mekanik',
    inspectionDate: 'Tarikh Pemeriksaan',
    requestedDate: 'Tarikh Diminta',
    location: 'Lokasi',
    inspectionSummaryTitle: 'Ringkasan Pemeriksaan',
    checkpointsInspected: '200+ pusat pemeriksaan diperiksa',
    assessmentTitle: 'Penilaian',
    vehicleInformationTitle: 'Maklumat Kenderaan',
    make: 'Jenama',
    owners: 'Pemilik',
    model: 'Model',
    transmission: 'Transmisi',
    year: 'Tahun',
    regNo: 'Reg No',
    mfgDate: 'Tarikh Mfg',
    fuel: 'Minyak',
    colour: 'Warna',
    regDate: 'Reg. tarikh',
    engineCC: 'CC Enjin',
    engineNumber: 'Enjin No',
    chassisNo: 'No Chasis',
    keyInformation: 'Maklumat Kunci',
    kmsDriven: 'KMS Digerakkan',
    majorAccident: 'Kemalangan Besar',
    floodDamage: 'Kerugian Banjir',
    engineCondition: 'Keadaan Enjin',
    transmission: 'Transmisi',
    exteriorCondition: 'Keadaan Luaran',
    interiorCondition: 'Keadaan Dalaman',
    dentsScratches: 'Dents & Calar',
    avgTyreLife: 'Purata Hayat Tyre',
    insurance: 'Insurans',
    majorRepair: 'Pembetulan Utama',
    minorRepair: 'Pembetulan Kecil',
    obd2ScanningReport: 'OBD2 Laporan Pengimbasan',
    easy: 'Mudah Dibaca',
    made: 'Dibuat untuk pemahaman yang mudah tentang setiap butiran laporan pemeriksaan anda pada mudah alih.',
    track: 'Mudah Dijejaki',
    trackMade:
      'Dapatkan butiran lengkap perbelanjaan selepas pembelian sebelum membeli kereta terpakai.',
    report: 'Laporan Komprehensif',
    reportMade:
      'Laporan ini dijana menggunakan Pemeriksaan Fizikal, AI, Pengimbasan OBD2 menggunakan alat pengimbasan terkini.',
    dec1Content: (
      <>
        <p style={{ paddingTop: '0px' }}>
          Wisedrive Technologies (M) Sdn. Bhd.
        </p>
        <p style={{ paddingTop: '0px' }}>Lot 2F, Jalan 215, Seksyen 51,</p>
        <p style={{ paddingTop: '0px' }}>Petaling Jaya, Selangor, </p>
        <p style={{ paddingTop: '0px' }}> Malaysia 46050</p>
      </>
    ),
  },
};
